// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Prompt:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Thai", "Sukhumvit Set", "Noto Sans Thai", Prompt, "Helvetica Neue", Helvetica, Arial, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html {
    /* ปรับฐานฟอนต์ให้พอดีกับจอ: มือถือเล็กหน่อย PC กำลังดี */
    font-size: 14px;
    scroll-behavior: smooth;
  }
  
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @media (min-width: 768px) {
    html {
      font-size: 15px;
    }
  }

  @media (min-width: 1280px) {
    html {
      font-size: 16px;
    }
  }

  body{
  margin: 0px;
  overflow-x: hidden;
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
  padding: 0px;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Thai", "Sukhumvit Set", "Noto Sans Thai", Prompt, "Helvetica Neue", Helvetica, Arial, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(29 29 31 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 500ms;
}

  body:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* letter-spacing เล็กน้อยเพื่อให้เหมือน Apple SF Pro */
    letter-spacing: -0.015em;
  }

  /* Force no italic globally as requested */
  i,
  em,
  .italic,
  .font-italic {
    font-style: normal !important;
  }

  /* Fixed Background Pattern: ลื่นหัวแตกเพราะใช้ Layer แยก */
  body::before {
    content: "";
    pointer-events: none;
    position: fixed;
    inset: 0px;
    z-index: -50;
    background-image:
      radial-gradient(at 0% 0%, rgba(37, 99, 235, 0.03) 0px, transparent 50%),
      radial-gradient(at 100% 100%,
        rgba(37, 99, 235, 0.03) 0px,
        transparent 50%);
  }

  /* เจาะจงตัวห่อหน้าเท่านั้น ไม่ใช่ <main> ทุกตัว ดูเหตุผลที่กฎด้านล่าง */
  #main-scroll-container > main{
  min-height: 80vh;
}

  a{
  color: inherit;
  text-decoration-line: none;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 200ms;
}

  ul{
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb{
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}

  html.dark ::-webkit-scrollbar-thumb {
  background-color: #32324a;
}

  .xl-doc :is(.rounded,, .rounded-lg, .rounded-xl, .rounded-2xl, .rounded-3xl, [class*="rounded-["])::-webkit-scrollbar-thumb:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }

  ::-webkit-scrollbar-thumb:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}

  /*  แอนิเมชัน Dropdown: เด้งดึ๋ง ทันสมัย */
  @keyframes slideDownPop {
    from {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .animate-slideDownPop {
    animation: slideDownPop 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    will-change: opacity, transform;
    position: relative;
  }

  /* สะพานล่องหนเชื่อมปุ่มกับเมนู */
  .animate-slideDownPop::before {
    content: "";
    position: absolute;
    top: -1rem;
    left: 0px;
    right: 0px;
    height: 1rem;
    background-color: transparent;
  }

  /* Mobile Accordion */

  .accordion-grid.\\!open {
    grid-template-rows: 1fr !important;
  }

  .accordion-grid.open {
    grid-template-rows: 1fr;
  }

  /* Page Transition */
  @keyframes pageFade {
    0% {
      opacity: 0;
      transform: translateY(10px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-pageFade {
    animation: pageFade 0.4s ease-out forwards;
    will-change: opacity, transform;
  }

  @keyframes modalIn {
    from { opacity: 0; transform: scale(0.92) translateY(-8px); }
    to   { opacity: 1; transform: scale(1)    translateY(0);     }
  }

  /* ️ Utility: Hide scrollbar but keep functionality */
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }

  .scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  /* Apple Style Buttons (Monochrome) */
  .btn-apple-primary{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: transparent;
  background-color: var(--color-primary);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 500;
  color: var(--color-primary-text);
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  html.dark .btn-apple-primary {
  border-color: #2e2e3a;
}
  
html.dark .btn-apple-primary {
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  html.dark .btn-apple-primary {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
}
  .btn-apple-primary {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl,.btn-apple-primary, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .xl-doc :is(.shadow,.btn-apple-primary, .shadow-md, .shadow-lg, .shadow-xl, .shadow-2xl):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { box-shadow: 0 1px 2px rgba(0, 0, 0, .08); }
  .btn-apple-primary:hover{
  background-color: var(--color-primary-hover);
}
  .btn-apple-primary:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .btn-apple-primary {
    will-change: transform, background-color;
    transform: translateZ(0);
  }
  
  .btn-apple-secondary{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 1.5rem;
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(232 232 237 / var(--tw-bg-opacity, 1));
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(29 29 31 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  
  html.dark .btn-apple-secondary {
  border-color: #2e2e3a;
}
  
  
html.dark .btn-apple-secondary {
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl,.btn-apple-secondary, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  
  .btn-apple-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 209 214 / var(--tw-bg-opacity, 1));
}
  
  .btn-apple-secondary:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .btn-apple-secondary:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(44 44 46 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}
  
  .btn-apple-secondary:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 60 / var(--tw-bg-opacity, 1));
}
  
  .btn-apple-secondary {
    will-change: transform, background-color;
    transform: translateZ(0);
  }

  /* Apple Input Focus Ring */
  .apple-input{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 1.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(29 29 31 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  html.dark .apple-input {
  background-color: #1a1a24;
}
  
html.dark .apple-input {
  border-color: #2e2e3a;
}
  html.dark .apple-input {
  border-color: #2e2e3a;
}
  
html.dark .apple-input {
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg,.apple-input, .rounded-2xl, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .xl-doc :is(.border-slate-100,.apple-input, .border-gray-100, .border-gray-200):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #c8d0ca; }
  .apple-input:focus{
  border-color: var(--color-primary);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(0 0 0 / 0.2);
}
  .apple-input:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(56 56 58 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}
  .apple-input:focus:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.2);
}

  /* Smooth Hover Scale for Cards */

  /* Apple Style Minimalist Spinner */
  @keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
  .apple-spinner{
  animation: spin 1s linear infinite;
  border-radius: 9999px;
  border-width: 3px;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-border-opacity: 1;
  border-top-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
  
html.dark .apple-spinner {
  border-color: #2e2e3a;
}
  .xl-doc :is(button, a, label).apple-spinner:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .xl-doc :is(.border-slate-100,.apple-spinner, .border-gray-100, .border-gray-200):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #c8d0ca; }
  .apple-spinner:is(.dark *){
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
  /* Apple Form Group (iOS Inset Grouped) */
  .apple-form-group{
  border-radius: 2rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.5rem;
  --tw-shadow: 0 2px 10px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
  html.dark .apple-form-group {
  background-color: #1a1a24;
  border-color: #2e2e3a;
}
  .xl-doc :is(.apple-form-group, .border-slate-200, .border-gray-100, .border-gray-200):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #c8d0ca; }
  .apple-form-group:is(.dark *){
  border-color: rgb(255 255 255 / 0.05);
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}

  /* Extreme Smoothness Buttons */
  .btn-apple-success{
  display: flex;
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  
html.dark .btn-apple-success {
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl,.btn-apple-success, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .btn-apple-success:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-shadow-color: rgb(16 185 129 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
  .btn-apple-success:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .btn-apple-danger{
  display: flex;
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  
html.dark .btn-apple-danger {
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl,.btn-apple-danger, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .btn-apple-danger:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-shadow-color: rgb(239 68 68 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
  .btn-apple-danger:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .btn-apple-secondary{
  display: flex;
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
  
html.dark .btn-apple-secondary {
  background-color: #1e1e28;
  background-color: #1a1a24;
  border: 1px solid #2e2e3a;
}
  .xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl,.btn-apple-secondary, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px; }
  .btn-apple-secondary:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
  .btn-apple-secondary:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  .btn-apple-secondary:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(44 44 46 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  .btn-apple-secondary:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 60 / var(--tw-bg-opacity, 1));
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-28{
  bottom: -7rem;
}
.-bottom-4{
  bottom: -1rem;
}
.-bottom-6{
  bottom: -1.5rem;
}
.-bottom-px{
  bottom: -1px;
}
.-left-20{
  left: -5rem;
}
.-left-7{
  left: -1.75rem;
}
.-left-\\[7px\\]{
  left: -7px;
}
.-left-\\[9999px\\]{
  left: -9999px;
}
.-left-\\[9px\\]{
  left: -9px;
}
.-right-1{
  right: -0.25rem;
}
.-right-1\\.5{
  right: -0.375rem;
}
.-right-10{
  right: -2.5rem;
}
.-right-16{
  right: -4rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-4{
  right: -1rem;
}
.-right-6{
  right: -1.5rem;
}
.-right-px{
  right: -1px;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-10{
  top: -2.5rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-4{
  top: -1rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[calc\\(6rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
  bottom: calc(6rem + env(safe-area-inset-bottom));
}
.bottom-full{
  bottom: 100%;
}
.end-0{
  inset-inline-end: 0px;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-1\\/4{
  left: 25%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-3\\.5{
  left: 0.875rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-6{
  left: 1.5rem;
}
.left-7{
  left: 1.75rem;
}
.left-8{
  left: 2rem;
}
.left-\\[1\\.375rem\\]{
  left: 1.375rem;
}
.left-\\[5mm\\]{
  left: 5mm;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\/4{
  right: 25%;
}
.right-2{
  right: 0.5rem;
}
.right-2\\.5{
  right: 0.625rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-8{
  right: 2rem;
}
.right-\\[10mm\\]{
  right: 10mm;
}
.right-\\[20px\\]{
  right: 20px;
}
.start-0{
  inset-inline-start: 0px;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-24{
  top: 6rem;
}
.top-3{
  top: 0.75rem;
}
.top-3\\.5{
  top: 0.875rem;
}
.top-4{
  top: 1rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[10mm\\]{
  top: 10mm;
}
.top-\\[4\\.25rem\\]{
  top: 4.25rem;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[0\\]{
  z-index: 0;
}
.z-\\[100000\\]{
  z-index: 100000;
}
.z-\\[100001\\]{
  z-index: 100001;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[10010\\]{
  z-index: 10010;
}
.z-\\[10020\\]{
  z-index: 10020;
}
.z-\\[10050\\]{
  z-index: 10050;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1050\\]{
  z-index: 1050;
}
.z-\\[1100\\]{
  z-index: 1100;
}
.z-\\[110\\]{
  z-index: 110;
}
.z-\\[120\\]{
  z-index: 120;
}
.z-\\[2000\\]{
  z-index: 2000;
}
.z-\\[61\\]{
  z-index: 61;
}
.z-\\[99990\\]{
  z-index: 99990;
}
.z-\\[99999\\]{
  z-index: 99999;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.order-3{
  order: 3;
}
.order-4{
  order: 4;
}
.order-first{
  order: -9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-11{
  grid-column: span 11 / span 11;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-8{
  grid-column: span 8 / span 8;
}
.col-span-full{
  grid-column: 1 / -1;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.row-start-1{
  grid-row-start: 1;
}
.-m-1\\.5{
  margin: -0.375rem;
}
.m-0{
  margin: 0px;
}
.m-2{
  margin: 0.5rem;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-5{
  margin: 1.25rem;
}
.m-auto{
  margin: auto;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5{
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-2\\.5{
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-0\\.5{
  margin-bottom: -0.125rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-2\\.5{
  margin-left: -0.625rem;
}
.-mr-16{
  margin-right: -4rem;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.-mt-16{
  margin-top: -4rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-8{
  margin-top: -2rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[-2px\\]{
  margin-bottom: -2px;
}
.mb-\\[0\\.75rem\\]{
  margin-bottom: 0.75rem;
}
.mb-\\[0\\.85rem\\]{
  margin-bottom: 0.85rem;
}
.mb-\\[1rem\\]{
  margin-bottom: 1rem;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-3{
  margin-inline-end: 0.75rem;
}
.me-4{
  margin-inline-end: 1rem;
}
.me-auto{
  margin-inline-end: auto;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-10{
  margin-left: 2.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-auto{
  margin-right: auto;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
.ms-5{
  margin-inline-start: 1.25rem;
}
.ms-auto{
  margin-inline-start: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[1rem\\]{
  margin-top: 1rem;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.\\!grid{
  display: grid !important;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[2\\/1\\]{
  aspect-ratio: 2/1;
}
.aspect-\\[3\\/2\\]{
  aspect-ratio: 3/2;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.\\!h-11{
  height: 2.75rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.\\!h-auto{
  height: auto !important;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[1123px\\]{
  height: 1123px;
}
.h-\\[14px\\]{
  height: 14px;
}
.h-\\[16px\\]{
  height: 16px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[30\\%\\]{
  height: 30%;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[45\\%\\]{
  height: 45%;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[48px\\]{
  height: 48px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[54px\\]{
  height: 54px;
}
.h-\\[55\\%\\]{
  height: 55%;
}
.h-\\[55px\\]{
  height: 55px;
}
.h-\\[6\\.5mm\\]{
  height: 6.5mm;
}
.h-\\[640px\\]{
  height: 640px;
}
.h-\\[64px\\]{
  height: 64px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[7mm\\]{
  height: 7mm;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-\\[94dvh\\]{
  height: 94dvh;
}
.h-\\[calc\\(100dvh-9rem\\)\\]{
  height: calc(100dvh - 9rem);
}
.h-\\[calc\\(100dvh_-_6rem\\)\\]{
  height: calc(100dvh - 6rem);
}
.h-\\[min\\(32rem\\2c calc\\(100dvh-6rem\\)\\)\\]{
  height: min(32rem, calc(100dvh - 6rem));
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-16{
  max-height: 4rem;
}
.max-h-20{
  max-height: 5rem;
}
.max-h-24{
  max-height: 6rem;
}
.max-h-32{
  max-height: 8rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-7{
  max-height: 1.75rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-8{
  max-height: 2rem;
}
.max-h-80{
  max-height: 20rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[14rem\\]{
  max-height: 14rem;
}
.max-h-\\[17rem\\]{
  max-height: 17rem;
}
.max-h-\\[22rem\\]{
  max-height: 22rem;
}
.max-h-\\[32rem\\]{
  max-height: 32rem;
}
.max-h-\\[35vh\\]{
  max-height: 35vh;
}
.max-h-\\[40vh\\]{
  max-height: 40vh;
}
.max-h-\\[45vh\\]{
  max-height: 45vh;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-\\[52vh\\]{
  max-height: 52vh;
}
.max-h-\\[580px\\]{
  max-height: 580px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[62vh\\]{
  max-height: 62vh;
}
.max-h-\\[70mm\\]{
  max-height: 70mm;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90mm\\]{
  max-height: 90mm;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[92dvh\\]{
  max-height: 92dvh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-\\[94vh\\]{
  max-height: 94vh;
}
.max-h-\\[95vh\\]{
  max-height: 95vh;
}
.max-h-\\[calc\\(100vh-230px\\)\\]{
  max-height: calc(100vh - 230px);
}
.max-h-\\[calc\\(92dvh-140px\\)\\]{
  max-height: calc(92dvh - 140px);
}
.max-h-\\[min\\(34rem\\2c calc\\(100dvh-6rem\\)\\)\\]{
  max-height: min(34rem, calc(100dvh - 6rem));
}
.max-h-\\[min\\(36rem\\2c calc\\(100dvh-6rem\\)\\)\\]{
  max-height: min(36rem, calc(100dvh - 6rem));
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[0\\.6rem\\]{
  min-height: 0.6rem;
}
.min-h-\\[100dvh\\]{
  min-height: 100dvh;
}
.min-h-\\[10rem\\]{
  min-height: 10rem;
}
.min-h-\\[1123px\\]{
  min-height: 1123px;
}
.min-h-\\[2\\.25rem\\]{
  min-height: 2.25rem;
}
.min-h-\\[2\\.5rem\\]{
  min-height: 2.5rem;
}
.min-h-\\[2\\.75rem\\]{
  min-height: 2.75rem;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[20rem\\]{
  min-height: 20rem;
}
.min-h-\\[28px\\]{
  min-height: 28px;
}
.min-h-\\[2rem\\]{
  min-height: 2rem;
}
.min-h-\\[3\\.5rem\\]{
  min-height: 3.5rem;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[32rem\\]{
  min-height: 32rem;
}
.min-h-\\[350px\\]{
  min-height: 350px;
}
.min-h-\\[3rem\\]{
  min-height: 3rem;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[50vh\\]{
  min-height: 50vh;
}
.min-h-\\[600px\\]{
  min-height: 600px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[64px\\]{
  min-height: 64px;
}
.min-h-\\[6rem\\]{
  min-height: 6rem;
}
.min-h-\\[70vh\\]{
  min-height: 70vh;
}
.min-h-\\[80vh\\]{
  min-height: 80vh;
}
.min-h-\\[calc\\(100dvh-61px\\)\\]{
  min-height: calc(100dvh - 61px);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-24{
  width: 6rem !important;
}
.\\!w-72{
  width: 18rem !important;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/12{
  width: 41.666667%;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-7\\/12{
  width: 58.333333%;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[10rem\\]{
  width: 10rem;
}
.w-\\[11rem\\]{
  width: 11rem;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[12rem\\]{
  width: 12rem;
}
.w-\\[13\\.5rem\\]{
  width: 13.5rem;
}
.w-\\[13rem\\]{
  width: 13rem;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[15rem\\]{
  width: 15rem;
}
.w-\\[17\\.5rem\\]{
  width: 17.5rem;
}
.w-\\[17rem\\]{
  width: 17rem;
}
.w-\\[18\\%\\]{
  width: 18%;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[2\\.75rem\\]{
  width: 2.75rem;
}
.w-\\[20rem\\]{
  width: 20rem;
}
.w-\\[210mm\\]{
  width: 210mm;
}
.w-\\[22\\%\\]{
  width: 22%;
}
.w-\\[22rem\\]{
  width: 22rem;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[34\\%\\]{
  width: 34%;
}
.w-\\[38\\%\\]{
  width: 38%;
}
.w-\\[390px\\]{
  width: 390px;
}
.w-\\[3rem\\]{
  width: 3rem;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[48px\\]{
  width: 48px;
}
.w-\\[4rem\\]{
  width: 4rem;
}
.w-\\[5\\.5rem\\]{
  width: 5.5rem;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[56px\\]{
  width: 56px;
}
.w-\\[5rem\\]{
  width: 5rem;
}
.w-\\[6\\.5rem\\]{
  width: 6.5rem;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[62px\\]{
  width: 62px;
}
.w-\\[6rem\\]{
  width: 6rem;
}
.w-\\[7\\.5rem\\]{
  width: 7.5rem;
}
.w-\\[794px\\]{
  width: 794px;
}
.w-\\[7rem\\]{
  width: 7rem;
}
.w-\\[8\\.5mm\\]{
  width: 8.5mm;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[85\\%\\]{
  width: 85%;
}
.w-\\[9mm\\]{
  width: 9mm;
}
.w-\\[9rem\\]{
  width: 9rem;
}
.w-\\[min\\(18rem\\2c 100\\%\\)\\]{
  width: min(18rem, 100%);
}
.w-\\[min\\(20rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\]{
  width: min(20rem, calc(100vw - 1.5rem));
}
.w-\\[min\\(22rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\]{
  width: min(22rem, calc(100vw - 1.5rem));
}
.w-\\[min\\(22rem\\2c calc\\(100vw-2\\.5rem\\)\\)\\]{
  width: min(22rem, calc(100vw - 2.5rem));
}
.w-\\[min\\(24rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\]{
  width: min(24rem, calc(100vw - 1.5rem));
}
.w-\\[min\\(26rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\]{
  width: min(26rem, calc(100vw - 1.5rem));
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[0\\.6rem\\]{
  min-width: 0.6rem;
}
.min-w-\\[1\\.25rem\\]{
  min-width: 1.25rem;
}
.min-w-\\[1\\.2rem\\]{
  min-width: 1.2rem;
}
.min-w-\\[1000px\\]{
  min-width: 1000px;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[107rem\\]{
  min-width: 107rem;
}
.min-w-\\[10rem\\]{
  min-width: 10rem;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[1180px\\]{
  min-width: 1180px;
}
.min-w-\\[11rem\\]{
  min-width: 11rem;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[14rem\\]{
  min-width: 14rem;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[16rem\\]{
  min-width: 16rem;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[17rem\\]{
  min-width: 17rem;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[18rem\\]{
  min-width: 18rem;
}
.min-w-\\[2\\.25rem\\]{
  min-width: 2.25rem;
}
.min-w-\\[2\\.5rem\\]{
  min-width: 2.5rem;
}
.min-w-\\[2\\.75rem\\]{
  min-width: 2.75rem;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[2rem\\]{
  min-width: 2rem;
}
.min-w-\\[3\\.5rem\\]{
  min-width: 3.5rem;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[30rem\\]{
  min-width: 30rem;
}
.min-w-\\[32rem\\]{
  min-width: 32rem;
}
.min-w-\\[34rem\\]{
  min-width: 34rem;
}
.min-w-\\[40px\\]{
  min-width: 40px;
}
.min-w-\\[40rem\\]{
  min-width: 40rem;
}
.min-w-\\[44rem\\]{
  min-width: 44rem;
}
.min-w-\\[46rem\\]{
  min-width: 46rem;
}
.min-w-\\[48rem\\]{
  min-width: 48rem;
}
.min-w-\\[52rem\\]{
  min-width: 52rem;
}
.min-w-\\[55px\\]{
  min-width: 55px;
}
.min-w-\\[55rem\\]{
  min-width: 55rem;
}
.min-w-\\[56rem\\]{
  min-width: 56rem;
}
.min-w-\\[58rem\\]{
  min-width: 58rem;
}
.min-w-\\[6\\.5rem\\]{
  min-width: 6.5rem;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[60rem\\]{
  min-width: 60rem;
}
.min-w-\\[640px\\]{
  min-width: 640px;
}
.min-w-\\[64px\\]{
  min-width: 64px;
}
.min-w-\\[64rem\\]{
  min-width: 64rem;
}
.min-w-\\[68rem\\]{
  min-width: 68rem;
}
.min-w-\\[70mm\\]{
  min-width: 70mm;
}
.min-w-\\[70rem\\]{
  min-width: 70rem;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[72rem\\]{
  min-width: 72rem;
}
.min-w-\\[76rem\\]{
  min-width: 76rem;
}
.min-w-\\[78rem\\]{
  min-width: 78rem;
}
.min-w-\\[860px\\]{
  min-width: 860px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[9\\.5rem\\]{
  min-width: 9.5rem;
}
.min-w-\\[960px\\]{
  min-width: 960px;
}
.min-w-\\[9rem\\]{
  min-width: 9rem;
}
.min-w-fit{
  min-width: fit-content;
}
.min-w-full{
  min-width: 100%;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[10rem\\]{
  max-width: 10rem;
}
.max-w-\\[11rem\\]{
  max-width: 11rem;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[1280px\\]{
  max-width: 1280px;
}
.max-w-\\[12rem\\]{
  max-width: 12rem;
}
.max-w-\\[13rem\\]{
  max-width: 13rem;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[14rem\\]{
  max-width: 14rem;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[15rem\\]{
  max-width: 15rem;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[20rem\\]{
  max-width: 20rem;
}
.max-w-\\[210mm\\]{
  max-width: 210mm;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[22rem\\]{
  max-width: 22rem;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[30\\%\\]{
  max-width: 30%;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[40\\%\\]{
  max-width: 40%;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[45\\%\\]{
  max-width: 45%;
}
.max-w-\\[450px\\]{
  max-width: 450px;
}
.max-w-\\[50\\%\\]{
  max-width: 50%;
}
.max-w-\\[7rem\\]{
  max-width: 7rem;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[85vw\\]{
  max-width: 85vw;
}
.max-w-\\[8rem\\]{
  max-width: 8rem;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[95mm\\]{
  max-width: 95mm;
}
.max-w-\\[96rem\\]{
  max-width: 96rem;
}
.max-w-\\[96vw\\]{
  max-width: 96vw;
}
.max-w-\\[9rem\\]{
  max-width: 9rem;
}
.max-w-\\[min\\(42rem\\2c 78\\%\\)\\]{
  max-width: min(42rem, 78%);
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[1\\.8\\]{
  flex: 1.8 1;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.basis-48{
  flex-basis: 12rem;
}
.basis-56{
  flex-basis: 14rem;
}
.basis-64{
  flex-basis: 16rem;
}
.table-fixed{
  table-layout: fixed;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-top{
  transform-origin: top;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0\\.5{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-\\[25deg\\]{
  --tw-rotate: -25deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3{
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-6{
  --tw-rotate: 6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-\\[-1\\]{
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-\\[bounce_0\\.6s_ease-out_1\\]{
  animation: bounce 0.6s ease-out 1;
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes pageFade{

  0%{
    opacity: 0;
    transform: translateY(12px) translateZ(0);
  }

  100%{
    opacity: 1;
    transform: translateY(0) translateZ(0);
  }
}
.animate-pageFade{
  animation: pageFade 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.cursor-zoom-out{
  cursor: zoom-out;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-text{
  -webkit-user-select: text;
          user-select: text;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.scroll-mt-4{
  scroll-margin-top: 1rem;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.break-after-page{
  page-break-after: always;
  break-after: page;
}
.auto-cols-fr{
  grid-auto-columns: minmax(0, 1fr);
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-11{
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-\\[1fr_auto\\]{
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[4\\.5rem_1fr\\]{
  grid-template-columns: 4.5rem 1fr;
}
.grid-cols-\\[5\\.5rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 5.5rem minmax(0,1fr);
}
.grid-cols-\\[5rem_minmax\\(0\\2c 1fr\\)_2\\.75rem\\]{
  grid-template-columns: 5rem minmax(0,1fr) 2.75rem;
}
.grid-cols-\\[6\\.5rem_1fr\\]{
  grid-template-columns: 6.5rem 1fr;
}
.grid-cols-\\[6\\.5rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 6.5rem minmax(0,1fr);
}
.grid-cols-\\[6rem_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: 6rem minmax(0,1fr);
}
.grid-cols-\\[6rem_minmax\\(0\\2c 1fr\\)_2\\.75rem\\]{
  grid-template-columns: 6rem minmax(0,1fr) 2.75rem;
}
.grid-cols-\\[8rem_1fr\\]{
  grid-template-columns: 8rem 1fr;
}
.grid-cols-\\[auto_1fr\\]{
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\]{
  grid-template-columns: auto minmax(0,1fr);
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: auto minmax(0,1fr) auto;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
  grid-template-columns: minmax(0,1fr) auto;
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(15rem\\2c 1fr\\)\\)\\]{
  grid-template-columns: repeat(auto-fill,minmax(15rem,1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[1rem\\]{
  gap: 1rem;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-2\\.5{
  column-gap: 0.625rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-3\\.5{
  column-gap: 0.875rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-2\\.5{
  row-gap: 0.625rem;
}
.gap-y-3{
  row-gap: 0.75rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.gap-y-6{
  row-gap: 1.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-\\[1rem\\] > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-divide-opacity, 1));
}
.divide-amber-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-divide-opacity, 1));
}
.divide-rose-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-100\\/60 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(241 245 249 / 0.6);
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-divide-opacity, 1));
}
.divide-slate-300 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-divide-opacity, 1));
}
.divide-slate-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(245 245 247 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-clip{
  overflow: clip;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded-md{
  border-radius: 0.375rem !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1.5rem;
}
.rounded-3xl{
  border-radius: 2rem;
}
.rounded-\\[1\\.25rem\\]{
  border-radius: 1.25rem;
}
.rounded-\\[1\\.5rem\\]{
  border-radius: 1.5rem;
}
.rounded-\\[1rem\\]{
  border-radius: 1rem;
}
.rounded-\\[2\\.5rem\\]{
  border-radius: 2.5rem;
}
.rounded-\\[2rem\\]{
  border-radius: 2rem;
}
.rounded-\\[3\\.5rem\\]{
  border-radius: 3.5rem;
}
.rounded-\\[3rem\\]{
  border-radius: 3rem;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[4rem\\]{
  border-radius: 4rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 1rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 1.25rem;
}
.rounded-b-3xl{
  border-bottom-right-radius: 2rem;
  border-bottom-left-radius: 2rem;
}
.rounded-b-lg{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl{
  border-bottom-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-r-xl{
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
}
.rounded-t-\\[2rem\\]{
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
}
.rounded-t-md{
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-xl{
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
}
.rounded-bl-md{
  border-bottom-left-radius: 0.375rem;
}
.rounded-br-2xl{
  border-bottom-right-radius: 1.5rem;
}
.rounded-tl-md{
  border-top-left-radius: 0.375rem;
}
.rounded-tl-none{
  border-top-left-radius: 0px;
}
.rounded-tl-xl{
  border-top-left-radius: 1.25rem;
}
.rounded-tr-md{
  border-top-right-radius: 0.375rem;
}
.rounded-tr-none{
  border-top-right-radius: 0px;
}
.\\!border-0{
  border-width: 0px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-4{
  border-bottom-width: 4px;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[1\\.5px\\]{
  border-left-width: 1.5px;
}
.border-l-\\[1px\\]{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-t-\\[1px\\]{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-dotted{
  border-style: dotted;
}
.border-none{
  border-style: none;
}
.border-\\[\\#1a3764\\]{
  --tw-border-opacity: 1;
  border-color: rgb(26 55 100 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1d3b2a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(29 59 42 / var(--tw-border-opacity, 1));
}
.border-\\[\\#217346\\]{
  --tw-border-opacity: 1;
  border-color: rgb(33 115 70 / var(--tw-border-opacity, 1));
}
.border-\\[\\#5F9EA0\\]\\/20{
  border-color: rgb(95 158 160 / 0.2);
}
.border-\\[\\#b9cbbf\\]{
  --tw-border-opacity: 1;
  border-color: rgb(185 203 191 / var(--tw-border-opacity, 1));
}
.border-\\[\\#c8d0ca\\]{
  --tw-border-opacity: 1;
  border-color: rgb(200 208 202 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4dcd6\\]{
  --tw-border-opacity: 1;
  border-color: rgb(212 220 214 / var(--tw-border-opacity, 1));
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-100\\/50{
  border-color: rgb(254 243 199 / 0.5);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/50{
  border-color: rgb(253 230 138 / 0.5);
}
.border-amber-200\\/60{
  border-color: rgb(253 230 138 / 0.6);
}
.border-amber-200\\/80{
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/30{
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-600{
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-black\\/10{
  border-color: rgb(0 0 0 / 0.1);
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-100\\/50{
  border-color: rgb(219 234 254 / 0.5);
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/50{
  border-color: rgb(191 219 254 / 0.5);
}
.border-blue-200\\/60{
  border-color: rgb(191 219 254 / 0.6);
}
.border-blue-200\\/80{
  border-color: rgb(191 219 254 / 0.8);
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-50{
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity, 1));
}
.border-blue-500{
  border-color: var(--color-primary);
}
.border-blue-600{
  border-color: var(--color-primary);
}
.border-cyan-200{
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-cyan-200\\/60{
  border-color: rgb(165 243 252 / 0.6);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/50{
  border-color: rgb(209 250 229 / 0.5);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/50{
  border-color: rgb(167 243 208 / 0.5);
}
.border-emerald-200\\/60{
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-200\\/70{
  border-color: rgb(167 243 208 / 0.7);
}
.border-emerald-200\\/80{
  border-color: rgb(167 243 208 / 0.8);
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-300\\/90{
  border-color: rgb(110 231 183 / 0.9);
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-50{
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity, 1));
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20{
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-emerald-700{
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/50{
  border-color: rgb(229 231 235 / 0.5);
}
.border-gray-200\\/60{
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/50{
  border-color: rgb(224 231 255 / 0.5);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/50{
  border-color: rgb(199 210 254 / 0.5);
}
.border-indigo-200\\/60{
  border-color: rgb(199 210 254 / 0.6);
}
.border-indigo-200\\/80{
  border-color: rgb(199 210 254 / 0.8);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/30{
  border-color: rgb(99 102 241 / 0.3);
}
.border-indigo-500\\/40{
  border-color: rgb(99 102 241 / 0.4);
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-700{
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-orange-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.border-orange-600{
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-200\\/60{
  border-color: rgb(233 213 255 / 0.6);
}
.border-purple-200\\/70{
  border-color: rgb(233 213 255 / 0.7);
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-100\\/50{
  border-color: rgb(255 228 230 / 0.5);
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-200\\/50{
  border-color: rgb(254 205 211 / 0.5);
}
.border-rose-200\\/80{
  border-color: rgb(254 205 211 / 0.8);
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.border-rose-500{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-rose-600{
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity, 1));
}
.border-rose-700{
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity, 1));
}
.border-rose-800{
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-sky-100\\/80{
  border-color: rgb(224 242 254 / 0.8);
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-200\\/60{
  border-color: rgb(186 230 253 / 0.6);
}
.border-sky-200\\/80{
  border-color: rgb(186 230 253 / 0.8);
}
.border-sky-200\\/90{
  border-color: rgb(186 230 253 / 0.9);
}
.border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.border-sky-400{
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.border-sky-600{
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/50{
  border-color: rgb(226 232 240 / 0.5);
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-200\\/90{
  border-color: rgb(226 232 240 / 0.9);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-300\\/60{
  border-color: rgb(203 213 225 / 0.6);
}
.border-slate-300\\/80{
  border-color: rgb(203 213 225 / 0.8);
}
.border-slate-400{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.border-slate-50{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 247 / var(--tw-border-opacity, 1));
}
.border-slate-500{
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.border-slate-600{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/50{
  border-color: rgb(51 65 85 / 0.5);
}
.border-slate-700\\/80{
  border-color: rgb(51 65 85 / 0.8);
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-slate-900{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-teal-100{
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity, 1));
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity, 1));
}
.border-teal-400{
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.border-teal-600{
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-200\\/80{
  border-color: rgb(221 214 254 / 0.8);
}
.border-violet-300{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-violet-600{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60{
  border-color: rgb(255 255 255 / 0.6);
}
.border-yellow-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity, 1));
}
.border-zinc-700{
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.border-zinc-800{
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}
.border-zinc-800\\/30{
  border-color: rgb(39 39 42 / 0.3);
}
.border-zinc-900{
  --tw-border-opacity: 1;
  border-color: rgb(28 28 30 / var(--tw-border-opacity, 1));
}
.border-\\[\\#a3cfb0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(163 207 176 / var(--tw-border-opacity, 1));
}
.border-b-white{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-l-blue-500{
  border-left-color: var(--color-primary);
}
.border-l-emerald-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-l-indigo-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-l-red-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-l-slate-300{
  --tw-border-opacity: 1;
  border-left-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-t-black{
  --tw-border-opacity: 1;
  border-top-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-t-blue-600{
  border-top-color: var(--color-primary);
}
.border-t-indigo-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-opacity-25{
  --tw-border-opacity: 0.25;
}
.border-opacity-50{
  --tw-border-opacity: 0.5;
}
.\\!bg-emerald-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-rose-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0a0a0a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d1d1f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1d4ed8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e73be\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 115 190 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#217346\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(33 115 70 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#222\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(34 34 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#34c759\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(52 199 89 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#59a8a8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(89 168 168 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5F9EA0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(95 158 160 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5F9EA0\\]\\/10{
  background-color: rgb(95 158 160 / 0.1);
}
.bg-\\[\\#8B0000\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(139 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F1F5F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8F9FA\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFC\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDFDFD\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9dcd9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 220 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e2efda\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 239 218 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e3efe6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(227 239 230 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef3ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(238 243 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f5f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2f2f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f3f3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f4f6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3faf5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f9f5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f5f7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f8f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9fb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fafc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafcfb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 252 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fce4e4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 228 228 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcfdfe\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(252 253 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdfdfd\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff2cc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 242 204 / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/90{
  background-color: rgb(254 243 199 / 0.9);
}
.bg-amber-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/30{
  background-color: rgb(255 251 235 / 0.3);
}
.bg-amber-50\\/40{
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50{
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/60{
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-50\\/70{
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80{
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2);
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-amber-700{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-black\\/90{
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400\\/20{
  background-color: rgb(96 165 250 / 0.2);
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30{
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-blue-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-500{
  background-color: var(--color-primary);
}
.bg-blue-600{
  background-color: var(--color-primary);
}
.bg-blue-700{
  background-color: var(--color-primary-hover);
}
.bg-cyan-100\\/80{
  background-color: rgb(207 250 254 / 0.8);
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-700{
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100\\/50{
  background-color: rgb(209 250 229 / 0.5);
}
.bg-emerald-100\\/80{
  background-color: rgb(209 250 229 / 0.8);
}
.bg-emerald-100\\/90{
  background-color: rgb(209 250 229 / 0.9);
}
.bg-emerald-200{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.bg-emerald-200\\/80{
  background-color: rgb(167 243 208 / 0.8);
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/20{
  background-color: rgb(236 253 245 / 0.2);
}
.bg-emerald-50\\/30{
  background-color: rgb(236 253 245 / 0.3);
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50{
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60{
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70{
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/20{
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-700{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-50\\/40{
  background-color: rgb(253 244 255 / 0.4);
}
.bg-fuchsia-500{
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-600{
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/50{
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/30{
  background-color: rgb(240 253 244 / 0.3);
}
.bg-green-50\\/40{
  background-color: rgb(240 253 244 / 0.4);
}
.bg-green-50\\/60{
  background-color: rgb(240 253 244 / 0.6);
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100\\/70{
  background-color: rgb(224 231 255 / 0.7);
}
.bg-indigo-100\\/90{
  background-color: rgb(224 231 255 / 0.9);
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/30{
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-50\\/40{
  background-color: rgb(238 242 255 / 0.4);
}
.bg-indigo-50\\/50{
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/60{
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-50\\/70{
  background-color: rgb(238 242 255 / 0.7);
}
.bg-indigo-50\\/80{
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-50\\/85{
  background-color: rgb(238 242 255 / 0.85);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10{
  background-color: rgb(99 102 241 / 0.1);
}
.bg-indigo-500\\/60{
  background-color: rgb(99 102 241 / 0.6);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-700{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.bg-lime-700{
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity, 1));
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-400\\/20{
  background-color: rgb(251 146 60 / 0.2);
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-50\\/50{
  background-color: rgb(255 247 237 / 0.5);
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-100\\/70{
  background-color: rgb(243 232 255 / 0.7);
}
.bg-purple-100\\/80{
  background-color: rgb(243 232 255 / 0.8);
}
.bg-purple-400\\/20{
  background-color: rgb(192 132 252 / 0.2);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/20{
  background-color: rgb(250 245 255 / 0.2);
}
.bg-purple-50\\/30{
  background-color: rgb(250 245 255 / 0.3);
}
.bg-purple-50\\/50{
  background-color: rgb(250 245 255 / 0.5);
}
.bg-purple-50\\/60{
  background-color: rgb(250 245 255 / 0.6);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-700{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/30{
  background-color: rgb(254 242 242 / 0.3);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40{
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50{
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-50\\/60{
  background-color: rgb(255 241 242 / 0.6);
}
.bg-rose-50\\/90{
  background-color: rgb(255 241 242 / 0.9);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-rose-700{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-100\\/80{
  background-color: rgb(224 242 254 / 0.8);
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-sky-50\\/60{
  background-color: rgb(240 249 255 / 0.6);
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-sky-600{
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.bg-sky-700{
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/40{
  background-color: rgb(241 245 249 / 0.4);
}
.bg-slate-100\\/50{
  background-color: rgb(241 245 249 / 0.5);
}
.bg-slate-100\\/70{
  background-color: rgb(241 245 249 / 0.7);
}
.bg-slate-100\\/80{
  background-color: rgb(241 245 249 / 0.8);
}
.bg-slate-100\\/90{
  background-color: rgb(241 245 249 / 0.9);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/70{
  background-color: rgb(226 232 240 / 0.7);
}
.bg-slate-200\\/80{
  background-color: rgb(226 232 240 / 0.8);
}
.bg-slate-200\\/90{
  background-color: rgb(226 232 240 / 0.9);
}
.bg-slate-300{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/30{
  background-color: rgb(245 245 247 / 0.3);
}
.bg-slate-50\\/40{
  background-color: rgb(245 245 247 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(245 245 247 / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(245 245 247 / 0.6);
}
.bg-slate-50\\/70{
  background-color: rgb(245 245 247 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(245 245 247 / 0.8);
}
.bg-slate-50\\/90{
  background-color: rgb(245 245 247 / 0.9);
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-700{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/50{
  background-color: rgb(30 41 59 / 0.5);
}
.bg-slate-800\\/80{
  background-color: rgb(30 41 59 / 0.8);
}
.bg-slate-800\\/90{
  background-color: rgb(30 41 59 / 0.9);
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/20{
  background-color: rgb(15 23 42 / 0.2);
}
.bg-slate-900\\/30{
  background-color: rgb(15 23 42 / 0.3);
}
.bg-slate-900\\/40{
  background-color: rgb(15 23 42 / 0.4);
}
.bg-slate-900\\/50{
  background-color: rgb(15 23 42 / 0.5);
}
.bg-slate-900\\/60{
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-900\\/70{
  background-color: rgb(15 23 42 / 0.7);
}
.bg-slate-900\\/80{
  background-color: rgb(15 23 42 / 0.8);
}
.bg-slate-900\\/90{
  background-color: rgb(15 23 42 / 0.9);
}
.bg-slate-900\\/95{
  background-color: rgb(15 23 42 / 0.95);
}
.bg-slate-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-slate-950\\/60{
  background-color: rgb(2 6 23 / 0.6);
}
.bg-slate-950\\/70{
  background-color: rgb(2 6 23 / 0.7);
}
.bg-slate-950\\/80{
  background-color: rgb(2 6 23 / 0.8);
}
.bg-slate-950\\/90{
  background-color: rgb(2 6 23 / 0.9);
}
.bg-slate-950\\/95{
  background-color: rgb(2 6 23 / 0.95);
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-400\\/20{
  background-color: rgb(45 212 191 / 0.2);
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-50\\/50{
  background-color: rgb(240 253 250 / 0.5);
}
.bg-teal-50\\/60{
  background-color: rgb(240 253 250 / 0.6);
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-200\\/60{
  background-color: rgb(221 214 254 / 0.6);
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/40{
  background-color: rgb(245 243 255 / 0.4);
}
.bg-violet-50\\/70{
  background-color: rgb(245 243 255 / 0.7);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-violet-700{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25{
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50\\/50{
  background-color: rgb(254 252 232 / 0.5);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900\\/40{
  background-color: rgb(28 28 30 / 0.4);
}
.bg-zinc-900\\/50{
  background-color: rgb(28 28 30 / 0.5);
}
.bg-zinc-950{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/70{
  background-color: rgb(239 246 255 / 0.7);
}
.bg-opacity-10{
  --tw-bg-opacity: 0.1;
}
.bg-opacity-100{
  --tw-bg-opacity: 1;
}
.bg-opacity-25{
  --tw-bg-opacity: 0.25;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/20{
  --tw-gradient-from: rgb(0 0 0 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50\\/40{
  --tw-gradient-from: rgb(239 246 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: var(--color-primary) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-900{
  --tw-gradient-from: #1e3a8a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400{
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50{
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/60{
  --tw-gradient-from: rgb(236 253 245 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/90{
  --tw-gradient-from: rgb(236 253 245 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600{
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-500{
  --tw-gradient-from: #d946ef var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 70 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/40{
  --tw-gradient-from: rgb(238 242 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80{
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500\\/25{
  --tw-gradient-from: rgb(99 102 241 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900{
  --tw-gradient-from: #312e81 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400\\/30{
  --tw-gradient-from: rgb(251 146 60 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-900{
  --tw-gradient-from: #7c2d12 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900{
  --tw-gradient-from: #581c87 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50{
  --tw-gradient-from: #fff1f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500{
  --tw-gradient-from: #f43f5e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-50\\/90{
  --tw-gradient-from: rgb(240 249 255 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 249 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500{
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200{
  --tw-gradient-from: #e2e8f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(226 232 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50{
  --tw-gradient-from: #f5f5f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 245 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900{
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-900{
  --tw-gradient-from: #134e4a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(19 78 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50{
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-blue-50\\/40{
  --tw-gradient-to: rgb(239 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(239 246 255 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-800{
  --tw-gradient-to: rgb(30 64 175 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e40af var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-600{
  --tw-gradient-to: rgb(79 70 229 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4f46e5 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-950{
  --tw-gradient-to: rgb(30 27 75 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e1b4b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-800{
  --tw-gradient-to: rgb(154 52 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9a3412 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-800{
  --tw-gradient-to: rgb(107 33 168 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6b21a8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-50{
  --tw-gradient-to: rgb(245 245 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f5f5f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-50\\/30{
  --tw-gradient-to: rgb(240 253 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 253 250 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-50\\/40{
  --tw-gradient-to: rgb(240 253 250 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(240 253 250 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-600{
  --tw-gradient-to: rgb(13 148 136 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0d9488 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-800{
  --tw-gradient-to: rgb(17 94 89 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #115e59 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-100{
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
}
.to-amber-300\\/10{
  --tw-gradient-to: rgb(252 211 77 / 0.1) var(--tw-gradient-to-position);
}
.to-blue-100{
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: var(--color-primary) var(--tw-gradient-to-position);
}
.to-blue-700{
  --tw-gradient-to: var(--color-primary-hover) var(--tw-gradient-to-position);
}
.to-cyan-700{
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}
.to-emerald-100{
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-500{
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-green-50\\/60{
  --tw-gradient-to: rgb(240 253 244 / 0.6) var(--tw-gradient-to-position);
}
.to-indigo-50{
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-700{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.to-indigo-950{
  --tw-gradient-to: #1e1b4b var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-rose-100{
  --tw-gradient-to: #ffe4e6 var(--tw-gradient-to-position);
}
.to-sky-400\\/10{
  --tw-gradient-to: rgb(56 189 248 / 0.1) var(--tw-gradient-to-position);
}
.to-slate-100{
  --tw-gradient-to: #f1f5f9 var(--tw-gradient-to-position);
}
.to-slate-50\\/40{
  --tw-gradient-to: rgb(245 245 247 / 0.4) var(--tw-gradient-to-position);
}
.to-slate-50\\/60{
  --tw-gradient-to: rgb(245 245 247 / 0.6) var(--tw-gradient-to-position);
}
.to-slate-900{
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-50{
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-50{
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-50\\/60{
  --tw-gradient-to: rgb(245 243 255 / 0.6) var(--tw-gradient-to-position);
}
.to-violet-500{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-current{
  fill: currentColor;
}
.stroke-1{
  stroke-width: 1;
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-0\\.5{
  padding: 0.125rem !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-14{
  padding: 3.5rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[0\\.85rem\\]{
  padding: 0.85rem;
}
.p-\\[1\\.25rem\\]{
  padding: 1.25rem;
}
.p-\\[1\\.5rem\\]{
  padding: 1.5rem;
}
.p-\\[10mm\\]{
  padding: 10mm;
}
.p-\\[12mm\\]{
  padding: 12mm;
}
.p-\\[1rem\\]{
  padding: 1rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0\\.5rem\\]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-\\[0\\.75rem\\]{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-\\[0\\.85rem\\]{
  padding-left: 0.85rem;
  padding-right: 0.85rem;
}
.px-\\[1\\.25rem\\]{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-\\[1rem\\]{
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-48{
  padding-top: 12rem;
  padding-bottom: 12rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.3rem\\]{
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
.py-\\[0\\.45rem\\]{
  padding-top: 0.45rem;
  padding-bottom: 0.45rem;
}
.py-\\[0\\.4rem\\]{
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.py-\\[0\\.75rem\\]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-\\[0\\.85rem\\]{
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
}
.py-\\[1\\.5rem\\]{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-20{
  padding-bottom: 5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-28{
  padding-bottom: 7rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[calc\\(1rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.pb-\\[calc\\(1rem_\\+_env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.pb-\\[max\\(0\\.75rem\\2c env\\(safe-area-inset-bottom\\)\\)\\]{
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}
.pe-10{
  padding-inline-end: 2.5rem;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pe-3{
  padding-inline-end: 0.75rem;
}
.pe-4{
  padding-inline-end: 1rem;
}
.pe-5{
  padding-inline-end: 1.25rem;
}
.pe-8{
  padding-inline-end: 2rem;
}
.pl-0\\.5{
  padding-left: 0.125rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-1\\.5{
  padding-left: 0.375rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-14{
  padding-left: 3.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-7{
  padding-left: 1.75rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pl-\\[1rem\\]{
  padding-left: 1rem;
}
.pl-\\[3\\.75rem\\]{
  padding-left: 3.75rem;
}
.pl-\\[4\\.5rem\\]{
  padding-left: 4.5rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-1\\.5{
  padding-right: 0.375rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-11{
  padding-right: 2.75rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-20{
  padding-right: 5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-9{
  padding-right: 2.25rem;
}
.pr-\\[1rem\\]{
  padding-right: 1rem;
}
.ps-0{
  padding-inline-start: 0px;
}
.ps-1{
  padding-inline-start: 0.25rem;
}
.ps-10{
  padding-inline-start: 2.5rem;
}
.ps-2{
  padding-inline-start: 0.5rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.ps-4{
  padding-inline-start: 1rem;
}
.ps-5{
  padding-inline-start: 1.25rem;
}
.ps-8{
  padding-inline-start: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-3\\.5{
  padding-top: 0.875rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-7{
  padding-top: 1.75rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[12vh\\]{
  padding-top: 12vh;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.align-bottom{
  vertical-align: bottom;
}
.align-\\[-2px\\]{
  vertical-align: -2px;
}
.font-\\[\\'Prompt\\'\\]{
  font-family: 'Prompt';
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-prompt{
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Thai", "Sukhumvit Set", "Noto Sans Thai", Prompt, "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.font-sans{
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Thai", "Sukhumvit Set", "Noto Sans Thai", Prompt, "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl{
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14\\.5px\\]{
  font-size: 14.5px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[19px\\]{
  font-size: 19px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[32px\\]{
  font-size: 32px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[90px\\]{
  font-size: 90px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-\\[1\\.4\\]{
  line-height: 1.4;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.1em\\]{
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.\\!text-emerald-900{
  --tw-text-opacity: 1 !important;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0052cc\\]{
  --tw-text-opacity: 1;
  color: rgb(0 82 204 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00A651\\]{
  --tw-text-opacity: 1;
  color: rgb(0 166 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d1d1f\\]{
  --tw-text-opacity: 1;
  color: rgb(29 29 31 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d3b2a\\]{
  --tw-text-opacity: 1;
  color: rgb(29 59 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e3a8a\\]{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#217346\\]{
  --tw-text-opacity: 1;
  color: rgb(33 115 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2449b8\\]{
  --tw-text-opacity: 1;
  color: rgb(36 73 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5F9EA0\\]{
  --tw-text-opacity: 1;
  color: rgb(95 158 160 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f5f5f7\\]{
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}
.text-amber-200\\/90{
  color: rgb(253 230 138 / 0.9);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-50{
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  color: var(--color-primary);
}
.text-blue-600{
  color: var(--color-primary);
}
.text-blue-700{
  color: var(--color-primary-hover);
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-emerald-100{
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-700\\/70{
  color: rgb(4 120 87 / 0.7);
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-800\\/80{
  color: rgb(6 95 70 / 0.8);
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-950{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-fuchsia-700{
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-200{
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-400\\/60{
  color: rgb(129 140 248 / 0.6);
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-800\\/80{
  color: rgb(55 48 163 / 0.8);
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-indigo-950{
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity, 1));
}
.text-orange-200{
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}
.text-orange-400{
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-pink-800{
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-500\\/15{
  color: rgb(244 63 94 / 0.15);
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-600\\/70{
  color: rgb(2 132 199 / 0.7);
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-sky-950{
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-50{
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-slate-950{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.text-teal-200{
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-100{
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity, 1));
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-violet-950{
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.text-zinc-400{
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.decoration-indigo-200{
  text-decoration-color: #c7d2fe;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-slate-300::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(203 213 225 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-500::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#217346\\]{
  accent-color: #217346;
}
.accent-black{
  accent-color: #000;
}
.accent-blue-600{
  accent-color: var(--color-primary);
}
.accent-emerald-600{
  accent-color: #059669;
}
.accent-emerald-700{
  accent-color: #047857;
}
.accent-fuchsia-600{
  accent-color: #c026d3;
}
.accent-green-700{
  accent-color: #15803d;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.accent-pink-600{
  accent-color: #db2777;
}
.accent-rose-600{
  accent-color: #e11d48;
}
.accent-violet-600{
  accent-color: #7c3aed;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-5{
  opacity: 0.05;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.mix-blend-multiply{
  mix-blend-mode: multiply;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 0 -4px 10px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 -4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 20px rgba(59,130,246,0.3);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_-10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 10px 40px -10px rgba(0,0,0,0.08);
  --tw-shadow-colored: 0 10px 40px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_-15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 10px 40px -15px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 10px 40px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 0 1px 3px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\]{
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 0 2px 10px rgb(0,0,0,0.02);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 0 2px 10px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\]{
  --tw-shadow: 0 2px 15px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 2px 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 4px 20px -4px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 4px 20px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 4px 20px -4px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 4px 20px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_-4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\]{
  --tw-shadow: 0 4px 24px -4px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 4px 24px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_2px_4px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.6\\)\\]{
  --tw-shadow: inset 0 2px 4px rgba(255,255,255,0.6);
  --tw-shadow-colored: inset 0 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!shadow-rose-500\\/30{
  --tw-shadow-color: rgb(244 63 94 / 0.3) !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}
.shadow-amber-50{
  --tw-shadow-color: #fffbeb;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/10{
  --tw-shadow-color: rgb(245 158 11 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-600\\/30{
  --tw-shadow-color: rgb(217 119 6 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/20{
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/5{
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-100{
  --tw-shadow-color: #dbeafe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-200{
  --tw-shadow-color: #bfdbfe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/20{
  --tw-shadow-color: rgb(30 58 138 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-100{
  --tw-shadow-color: #d1fae5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-200{
  --tw-shadow-color: #a7f3d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-50{
  --tw-shadow-color: #ecfdf5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/10{
  --tw-shadow-color: rgb(16 185 129 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/20{
  --tw-shadow-color: rgb(16 185 129 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-500\\/30{
  --tw-shadow-color: rgb(16 185 129 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/20{
  --tw-shadow-color: rgb(5 150 105 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/30{
  --tw-shadow-color: rgb(5 150 105 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-900\\/10{
  --tw-shadow-color: rgb(6 78 59 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-100{
  --tw-shadow-color: #e0e7ff;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200{
  --tw-shadow-color: #c7d2fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20{
  --tw-shadow-color: rgb(99 102 241 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/5{
  --tw-shadow-color: rgb(99 102 241 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-600\\/20{
  --tw-shadow-color: rgb(79 70 229 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-900\\/20{
  --tw-shadow-color: rgb(124 45 18 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-900\\/20{
  --tw-shadow-color: rgb(88 28 135 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-100{
  --tw-shadow-color: #ffe4e6;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-200{
  --tw-shadow-color: #fecdd3;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-50{
  --tw-shadow-color: #fff1f2;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/10{
  --tw-shadow-color: rgb(244 63 94 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-500\\/30{
  --tw-shadow-color: rgb(244 63 94 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-600\\/30{
  --tw-shadow-color: rgb(225 29 72 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-100{
  --tw-shadow-color: #f1f5f9;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-200{
  --tw-shadow-color: #e2e8f0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-200\\/40{
  --tw-shadow-color: rgb(226 232 240 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-200\\/50{
  --tw-shadow-color: rgb(226 232 240 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-300{
  --tw-shadow-color: #cbd5e1;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-700\\/30{
  --tw-shadow-color: rgb(51 65 85 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-900\\/25{
  --tw-shadow-color: rgb(15 23 42 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-950\\/20{
  --tw-shadow-color: rgb(2 6 23 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-900\\/20{
  --tw-shadow-color: rgb(19 78 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-violet-500\\/20{
  --tw-shadow-color: rgb(139 92 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-2{
  outline-width: 2px;
}
.-outline-offset-2{
  outline-offset: -2px;
}
.outline-\\[\\#217346\\]{
  outline-color: #217346;
}
.outline-emerald-500{
  outline-color: #10b981;
}
.outline-slate-900{
  outline-color: #0f172a;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[3px\\]{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.\\!ring-amber-400{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1)) !important;
}
.\\!ring-slate-900{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1)) !important;
}
.ring-\\[\\#217346\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 115 70 / var(--tw-ring-opacity, 1));
}
.ring-amber-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity, 1));
}
.ring-amber-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-amber-400\\/20{
  --tw-ring-color: rgb(251 191 36 / 0.2);
}
.ring-amber-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 119 6 / var(--tw-ring-opacity, 1));
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-blue-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.ring-blue-500{
  --tw-ring-color: var(--color-primary);
}
.ring-blue-600{
  --tw-ring-color: var(--color-primary);
}
.ring-emerald-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(110 231 183 / var(--tw-ring-opacity, 1));
}
.ring-emerald-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 150 105 / var(--tw-ring-opacity, 1));
}
.ring-fuchsia-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 208 254 / var(--tw-ring-opacity, 1));
}
.ring-green-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-green-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 163 74 / var(--tw-ring-opacity, 1));
}
.ring-green-700{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 128 61 / var(--tw-ring-opacity, 1));
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-indigo-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.ring-indigo-50{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500\\/10{
  --tw-ring-color: rgb(99 102 241 / 0.1);
}
.ring-indigo-500\\/20{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
.ring-pink-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 168 212 / var(--tw-ring-opacity, 1));
}
.ring-red-500\\/10{
  --tw-ring-color: rgb(239 68 68 / 0.1);
}
.ring-rose-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity, 1));
}
.ring-rose-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-rose-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity, 1));
}
.ring-rose-300\\/40{
  --tw-ring-color: rgb(253 164 175 / 0.4);
}
.ring-rose-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 63 94 / var(--tw-ring-opacity, 1));
}
.ring-rose-500\\/70{
  --tw-ring-color: rgb(244 63 94 / 0.7);
}
.ring-rose-600{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(225 29 72 / var(--tw-ring-opacity, 1));
}
.ring-sky-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-slate-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity, 1));
}
.ring-slate-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-200\\/50{
  --tw-ring-color: rgb(226 232 240 / 0.5);
}
.ring-slate-200\\/80{
  --tw-ring-color: rgb(226 232 240 / 0.8);
}
.ring-slate-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity, 1));
}
.ring-slate-700{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 65 85 / var(--tw-ring-opacity, 1));
}
.ring-slate-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.ring-slate-950{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(2 6 23 / var(--tw-ring-opacity, 1));
}
.ring-teal-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity, 1));
}
.ring-teal-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(94 234 212 / var(--tw-ring-opacity, 1));
}
.ring-transparent{
  --tw-ring-color: transparent;
}
.ring-violet-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity, 1));
}
.ring-violet-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/5{
  --tw-ring-color: rgb(255 255 255 / 0.05);
}
.ring-offset-2{
  --tw-ring-offset-width: 2px;
}
.ring-offset-white{
  --tw-ring-offset-color: #fff;
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[1px\\]{
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  transition-duration: 400ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[-\\:T\\]{
  -: T;
}
.\\[overflow-wrap\\:anywhere\\]{
  overflow-wrap: anywhere;
}

:root {
  --color-primary: #000000;
  --color-primary-hover: #333333;
  --color-primary-text: #ffffff;
}

html.dark {
  --color-primary: #ffffff;
  --color-primary-hover: #e5e5ea;
  --color-primary-text: #000000;
}

/* NProgress Apple Style Override */
#nprogress .bar {
  background: var(--color-primary) !important;
  height: 3px !important;
}
#nprogress .peg {
  box-shadow: 0 0 10px var(--color-primary), 0 0 5px var(--color-primary) !important;
}
#nprogress .spinner-icon {
  border-top-color: var(--color-primary) !important;
  border-left-color: var(--color-primary) !important;
}

/* Dynamic Island Style Toasts */
.Toastify__toast-container {
  z-index: 99999 !important;
  top: 1rem !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: auto !important;
  max-width: 90vw !important;
}

.Toastify__toast {
  border-radius: 9999px !important;
  padding: 8px 16px !important;
  min-height: 48px !important;
  font-family: inherit !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.2) !important;
  margin-bottom: 0.5rem !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
}

/* Toastify Monochrome/Apple mapping */
.Toastify__toast-theme--colored.Toastify__toast--success {
  background: rgba(16, 185, 129, 0.9) !important;
  color: white !important;
}
.Toastify__toast-theme--colored.Toastify__toast--error {
  background: rgba(239, 68, 68, 0.9) !important;
  color: white !important;
}
.Toastify__toast-theme--colored.Toastify__toast--info {
  background: rgba(0, 0, 0, 0.85) !important;
  color: white !important;
}
.Toastify__toast-theme--colored.Toastify__toast--warning {
  background: rgba(245, 158, 11, 0.9) !important;
  color: white !important;
}

/* Spring Animations for Toasts */
@keyframes island-bounce {
  0% { transform: translateY(-150%) scale(0.9); opacity: 0; }
  60% { transform: translateY(10%) scale(1.02); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
}
.Toastify__bounce-enter--top-center {
  animation: island-bounce 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;
}

/*  Optimized Toast for Mobile (Global) */
@media (max-width: 640px) {
  .Toastify__toast-container {
    width: calc(100% - 24px) !important;
    left: 12px !important;
    top: 12px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .Toastify__toast {
    min-height: 44px !important;
    border-radius: 12px !important;
    margin-bottom: 10px !important;
    padding: 10px 14px !important;
    font-family: inherit !important;
    box-shadow: 0 8px 20px -5px rgba(0, 0, 0, 0.1) !important;
  }

  .Toastify__toast-body {
    font-size: 13px !important;
    font-weight: 500 !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1.4 !important;
  }

  .Toastify__toast-icon {
    width: 16px !important;
    margin-right: 10px !important;
    flex-shrink: 0 !important;
  }
}

/*
===================================================
ELEGANT DARK THEME
Modern dark theme with subtle depth and contrast.
===================================================
*/
html.dark body,
html.dark main,
html.dark section {
  background-color: #0f0f14 !important;
  color: #e2e8f0 !important;
}

/* Dark backgrounds with subtle depth */
html.dark .bg-white {
  background-color: #1a1a24 !important;
}

html.dark .bg-slate-50,
html.dark .bg-slate-100 {
  background-color: #1e1e28 !important;
}

html.dark .bg-slate-200 {
  background-color: #2a2a38 !important;
}

html.dark .bg-slate-800,
html.dark .bg-slate-900 {
  background-color: #000000 !important;
}

html.dark .bg-slate-950 {
  background-color: #000000 !important;
}

html.dark .bg-gray-50,
html.dark .bg-gray-100 {
  background-color: #1a1a24 !important;
}

html.dark .bg-gray-200 {
  background-color: #2a2a38 !important;
}

/* Cards and elevated surfaces */
html.dark .bg-slate-300,
html.dark .bg-gray-300 {
  background-color: #32324a !important;
}

/* Text colors - maintain readability */
html.dark h1,
html.dark h2,
html.dark h3,
html.dark h4,
html.dark h5,
html.dark h6 {
  color: #f1f5f9 !important;
}

html.dark p,
html.dark span,
html.dark div,
html.dark li,
html.dark ul {
  color: #cbd5e1 !important;
}

html.dark a {
  color: #94a3b8 !important;
}

html.dark a:hover {
  color: #e2e8f0 !important;
}

/*
===================================================
VIBRANT EXCEPTIONS
Allows critical UI elements (Stars, Status) to
retain their colors amidst the dark theme.
===================================================
*/
html.dark .text-yellow-400,
html.dark .text-yellow-500 {
  color: #facc15 !important;
}

html.dark .text-amber-400,
html.dark .text-amber-500 {
  color: #fbbf24 !important;
}

html.dark .text-rose-400,
html.dark .text-rose-500,
html.dark .text-rose-600 {
  color: #fb7185 !important;
}

html.dark .text-red-400,
html.dark .text-red-500 {
  color: #f87171 !important;
}

html.dark .text-emerald-400,
html.dark .text-emerald-500,
html.dark .text-emerald-600 {
  color: #34d399 !important;
}

html.dark .text-green-400,
html.dark .text-green-500 {
  color: #4ade80 !important;
}

html.dark .text-blue-400,
html.dark .text-blue-500 {
  color: #60a5fa !important;
}

html.dark .text-cyan-400,
html.dark .text-cyan-500 {
  color: #22d3ee !important;
}

html.dark .text-indigo-400,
html.dark .text-indigo-500 {
  color: #818cf8 !important;
}

html.dark .text-violet-400,
html.dark .text-violet-500 {
  color: #a78bfa !important;
}

html.dark .text-purple-400,
html.dark .text-purple-500 {
  color: #c084fc !important;
}

html.dark .text-pink-400,
html.dark .text-pink-500 {
  color: #f472b6 !important;
}

html.dark .text-orange-400,
html.dark .text-orange-500 {
  color: #fb923c !important;
}

/* Star Rating Specifics */
html.dark .star-filled {
  color: #facc15 !important;
}

html.dark .star-empty {
  color: #3f3f46 !important;
}

/* Primary/Secondary colors for buttons */
html.dark .text-primary {
  color: #60a5fa !important;
}

html.dark .text-secondary {
  color: #94a3b8 !important;
}

/* Ensure placeholders are visible but subdued in dark mode */
html.dark input::placeholder,
html.dark textarea::placeholder {
  color: #64748b !important;
}

/*
===================================================
BORDERS & INPUTS
===================================================
*/
/* Subtle borders for dark theme */
html.dark .border-slate-100,
html.dark .border-slate-200,
html.dark .border-gray-100,
html.dark .border-gray-200 {
  border-color: #2e2e3a !important;
}

html.dark .border-slate-300,
html.dark .border-gray-300 {
  border-color: #3f3f52 !important;
}

html.dark .border {
  border-color: #2e2e3a !important;
}

/* Input fields */
html.dark input,
html.dark textarea,
html.dark select {
  background-color: #1a1a24 !important;
  border-color: #2e2e3a !important;
  color: #e2e8f0 !important;
}

html.dark input:focus,
html.dark textarea:focus,
html.dark select:focus {
  background-color: #1e1e28 !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
}

html.dark input:disabled,
html.dark textarea:disabled,
html.dark select:disabled {
  background-color: #12121a !important;
  color: #64748b !important;
}

/*
===================================================
CARDS & CONTAINERS
===================================================
*/
html.dark .card,
html.dark .rounded-lg,
html.dark .rounded-xl,
html.dark .rounded-2xl {
  background-color: #1a1a24 !important;
  border: 1px solid #2e2e3a !important;
}

html.dark .bg-card,
html.dark .bg-white\\/50,
html.dark .bg-white\\/10 {
  background-color: #1a1a24 !important;
}

/*
===================================================
BUTTONS
===================================================
*/
html.dark button,
html.dark .btn {
  transition: all 0.2s ease;
}

html.dark .btn-primary,
html.dark .bg-blue-600,
html.dark .bg-blue-500 {
  background-color: var(--color-primary) !important;
  color: var(--color-primary-text) !important;
}

html.dark .btn-primary:hover,
html.dark .bg-blue-600:hover,
html.dark .bg-blue-500:hover {
  background-color: var(--color-primary-hover) !important;
}

html.dark .btn-secondary,
html.dark .bg-gray-500,
html.dark .bg-slate-500 {
  background-color: #3f3f52 !important;
  color: #e2e8f0 !important;
}

html.dark .btn-secondary:hover,
html.dark .bg-gray-500:hover,
html.dark .bg-slate-500:hover {
  background-color: #52525b !important;
}

html.dark .btn-outline-primary {
  border-color: #3b82f6 !important;
  color: #60a5fa !important;
}

html.dark .btn-outline-primary:hover {
  background-color: #1e40af !important;
  color: #ffffff !important;
}

html.dark .btn-outline-secondary {
  border-color: #475569 !important;
  color: #94a3b8 !important;
}

html.dark .btn-outline-secondary:hover {
  background-color: #334155 !important;
  color: #e2e8f0 !important;
}

/*
===================================================
TABLES
===================================================
*/
html.dark table {
  color: #e2e8f0 !important;
}

html.dark th,
html.dark td {
  border-color: #2e2e3a !important;
}

html.dark thead {
  background-color: #1e1e28 !important;
}

html.dark tbody tr:hover {
  background-color: #1a1a24 !important;
}

/*
===================================================
MODALS & OVERLAYS
===================================================
*/
html.dark .modal-content,
html.dark .dialog-content {
  background-color: #1a1a24 !important;
  border: 1px solid #2e2e3a !important;
}

html.dark .modal-header,
html.dark .modal-footer {
  border-color: #2e2e3a !important;
}

/*
===================================================
SCROLLBARS
===================================================
*/
html.dark ::-webkit-scrollbar-thumb {
  background-color: #3f3f52 !important;
}

html.dark ::-webkit-scrollbar-thumb:hover {
  background-color: #52526b !important;
}

/*
===================================================
BADGES & TAGS
===================================================
*/
html.dark .bg-blue-100,
html.dark .bg-blue-200 {
  background-color: #1e3a5f !important;
  color: #93c5fd !important;
}

html.dark .bg-green-100,
html.dark .bg-green-200 {
  background-color: #14532d !important;
  color: #86efac !important;
}

html.dark .bg-yellow-100,
html.dark .bg-yellow-200 {
  background-color: #422006 !important;
  color: #fde047 !important;
}

html.dark .bg-red-100,
html.dark .bg-red-200 {
  background-color: #450a0a !important;
  color: #fca5a5 !important;
}

html.dark .bg-gray-100,
html.dark .bg-gray-200 {
  background-color: #27272a !important;
  color: #a1a1aa !important;
}

/*
===================================================
NAVBAR & HEADER
===================================================
*/
html.dark nav,
html.dark header {
  background-color: #0f0f14 !important;
  border-bottom: 1px solid #2e2e3a !important;
}

/*
===================================================
FOOTER
===================================================
*/
html.dark footer {
  background-color: #0a0a0f !important;
  border-top: 1px solid #2e2e3a !important;
}

/*
===================================================
ALERTS & NOTIFICATIONS
===================================================
*/
html.dark .alert {
  border-color: #2e2e3a !important;
}

html.dark .alert-success {
  background-color: #05261f !important;
  border-color: #065f46 !important;
  color: #6ee7b7 !important;
}

html.dark .alert-danger {
  background-color: #450a0a !important;
  border-color: #991b1b !important;
  color: #fca5a5 !important;
}

html.dark .alert-warning {
  background-color: #422006 !important;
  border-color: #92400e !important;
  color: #fde047 !important;
}

html.dark .alert-info {
  background-color: #0c4a6e !important;
  border-color: #0369a1 !important;
  color: #7dd3fc !important;
}

/*
===================================================
DROPDOWN & SELECT
===================================================
*/
html.dark .dropdown-menu {
  background-color: #1a1a24 !important;
  border: 1px solid #2e2e3a !important;
}

html.dark .dropdown-item {
  color: #cbd5e1 !important;
}

html.dark .dropdown-item:hover {
  background-color: #2a2a38 !important;
  color: #f1f5f9 !important;
}

/*
===================================================
FORM GROUPS
===================================================
*/
html.dark .form-label {
  color: #94a3b8 !important;
}

html.dark .form-text {
  color: #64748b !important;
}

html.dark .form-check-input {
  background-color: #1a1a24 !important;
  border-color: #475569 !important;
}

html.dark .form-check-input:checked {
  background-color: #3b82f6 !important;
  border-color: #3b82f6 !important;
}

/*
===================================================
TABS
===================================================
*/
html.dark .nav-tabs {
  border-color: #2e2e3a !important;
}

html.dark .nav-tabs .nav-link {
  color: #94a3b8 !important;
}

html.dark .nav-tabs .nav-link:hover {
  color: #e2e8f0 !important;
  border-color: #3f3f52 !important;
}

html.dark .nav-tabs .nav-link.active {
  background-color: #1a1a24 !important;
  border-color: #2e2e3a #2e2e3a #1a1a24 !important;
  color: #f1f5f9 !important;
}

/*
===================================================
PAGINATION
===================================================
*/
html.dark .page-link {
  background-color: #1a1a24 !important;
  border-color: #2e2e3a !important;
  color: #94a3b8 !important;
}

html.dark .page-link:hover {
  background-color: #2a2a38 !important;
  color: #e2e8f0 !important;
}

html.dark .page-item.active .page-link {
  background-color: #3b82f6 !important;
  border-color: #3b82f6 !important;
  color: #ffffff !important;
}

/*
===================================================
SPINNER & LOADER
===================================================
*/
html.dark .spinner-border {
  border-color: #3f3f52 !important;
  border-top-color: #60a5fa !important;
}

/*
===================================================
SHADOWS - APPLE STYLE (Softer, wider spread)
===================================================
*/
html.dark .shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5) !important;
}

html.dark .shadow {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.5) !important;
}

html.dark .shadow-lg {
  box-shadow: 0 10px 30px -3px rgba(0, 0, 0, 0.6) !important;
}

/* Light mode overrides for Apple shadows */
.shadow-sm {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;
}

.shadow {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06) !important;
}

.shadow-lg {
  box-shadow: 0 12px 32px 0 rgba(0, 0, 0, 0.08) !important;
}

/*
===================================================
BACKDROP & OVERLAY
===================================================
*/
html.dark .backdrop-blur-sm {
  backdrop-filter: blur(4px);
  background-color: rgba(15, 15, 20, 0.8) !important;
}

/*
===================================================
CODE & PRE
===================================================
*/
html.dark code {
  background-color: #1e1e28 !important;
  color: #f472b6 !important;
}

html.dark pre {
  background-color: #12121a !important;
  border: 1px solid #2e2e3a !important;
  color: #e2e8f0 !important;
}

/*
===================================================
PAGETOOL CHROME PROTECTION
ป้องกัน legacy CSS (portal.css) เขียนทับ Header และ body
===================================================
*/
html,
body {
  height: auto !important;
  overflow: visible !important;
}

body {
  background-image: none !important;
  background-color: #f8fafc !important;
}

/* ══════════════════════════════════════════════════════════════════
   ลำดับชั้นการซ้อน (z-index) ของทั้งระบบ

   ต่ำ    เนื้อหาในหน้า                        auto - 30
          หัวข้อของแต่ละหน้าจอที่ sticky        30
   กลาง   หัวเว็บหลัก (components/Header)      999
   สูง    Modal · overlay เต็มจอ               10000
          Toast ในหน้า                        10010
          Lightbox ดูรูปเต็มจอ                 10020
   สูงสุด  Toastify (react-toastify)           99999

   ⚠ Modal ต้องอยู่เหนือหัวเว็บเสมอ ไม่ใช่ต่ำกว่า
     กฎเดิมบังคับ header ทุกตัวเป็น 9999 !important ซึ่งสูงกว่า z-50
     ที่ modal ใช้กันทั้งระบบ ผลคือหัวเว็บกับหัวหน้าจอทับหัว modal
     ปุ่มปิด (X) โดนบังจนกดไม่ได้ (เจอที่ /admin/payroll)
   ══════════════════════════════════════════════════════════════════ */

/* หัวเว็บหลัก — ต้อง sticky เสมอ ไม่ให้ถูกเนื้อหาบัง
   ⚠ เจาะจงที่ #app-header เท่านั้น
     เดิมเป็น header[class*="sticky"] ซึ่งจับ <header> ของทุกหน้าจอด้วย
     หัวข้อของหน้าจอเลยถูกดันขึ้นไป 9999 ตามไปด้วยโดยไม่มีใครตั้งใจ */
#app-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 999 !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

/* main เว้นพื้นที่ header
   จำกัดไว้เฉพาะ <main> ที่เป็นตัวห่อหน้า (ลูกโดยตรงของ #main-scroll-container)
   เดิมบังคับ <main> ทุกตัว ซึ่งไปโดน <main> ที่หน้าต่าง ๆ ใช้เป็นกล่องเนื้อหา
   ข้างในด้วย พอกล่องนั้นต้องสูงตามที่กำหนด มันจะล้นกรอบที่ครอบอยู่ */
#main-scroll-container > main {
  min-height: calc(100dvh - 300px);
}

/* ป้องกัน legacy portal.css ที่ใช้ aside, .nav-item เป็น global */
aside {
  position: static !important;
  z-index: auto !important;
}

/* ===================================================
   GLOBAL UI OVERHAUL (SMOOTH & MINIMALIST)
   =================================================== */

/* Base Smoothness */
body {
  color: #334155 !important;
  background-color: #f8fafc !important;
}
html.dark body {
  color: #e2e8f0 !important;
  background-color: #0f172a !important;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600 !important;
  color: #1e293b !important;
  letter-spacing: -0.02em;
}
html.dark h1, html.dark h2, html.dark h3, html.dark h4, html.dark h5, html.dark h6 {
  color: #f8fafc !important;
}

/* Transitions for everything interactive */
a, button, .btn, .card, .form-control, .form-select, .nav-link, .dropdown-item {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Modern Cards */
.card {
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.03) !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95) !important;
}
.card:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08) !important;
}
html.dark .card {
  border: 1px solid rgba(51, 65, 85, 0.5) !important;
  background: rgba(30, 41, 59, 0.95) !important;
  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.2) !important;
}
html.dark .card:hover {
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3) !important;
}

/* Modern Buttons */
.btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
}
.btn:hover {
  transform: scale(1.02) !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}
.btn:active {
  transform: scale(0.98) !important;
}

/* Inputs & Form Controls */
.form-control, .form-select {
  border-radius: 10px !important;
  border: 1px solid #cbd5e1 !important;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.02) !important;
}
.form-control:focus, .form-select:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
}
html.dark .form-control, html.dark .form-select {
  background-color: #0f172a !important;
  border-color: #334155 !important;
  color: #f1f5f9 !important;
}

/* Glassmorphism Header */
/* เจาะจงเฉพาะแถบบนของแอป ไม่ใช่ <header> ทุกตัวในระบบ
   เดิมเลือกด้วยชื่อแท็กล้วน ๆ จึงไปโดนแถบหัวเรื่องที่หน้าอื่นใช้ <header>
   ด้วย ทำให้กลายเป็นแถบขาวโปร่งกลางหน้าโดยไม่ได้ตั้งใจ
   แถบบนของแอปเป็น sticky เสมอ ใช้ตรงนั้นแยกออกจากกันได้ */
header.sticky, header[class*="sticky"], .navbar {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(12px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(12px) saturate(180%) !important;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8) !important;
}
html.dark header.sticky, html.dark header[class*="sticky"], html.dark .navbar {
  background: rgba(15, 23, 42, 0.8) !important;
  border-bottom: 1px solid rgba(51, 65, 85, 0.8) !important;
}

/* Tables */
.table {
  --bs-table-bg: transparent !important;
}
.table > :not(caption) > * > * {
  border-bottom-color: #f1f5f9 !important;
  padding: 1rem 0.75rem !important;
}
html.dark .table > :not(caption) > * > * {
  border-bottom-color: #1e293b !important;
}
.table thead th {
  font-weight: 600 !important;
  letter-spacing: 0.05em;
  color: #64748b !important;
  background-color: #f8fafc !important;
  border-bottom: 2px solid #e2e8f0 !important;
}
html.dark .table thead th {
  color: #94a3b8 !important;
  background-color: #0f172a !important;
  border-bottom: 2px solid #334155 !important;
}
.table tbody tr {
  transition: all 0.2s ease !important;
}
.table tbody tr:hover {
  background-color: #f1f5f9 !important;
}
html.dark .table tbody tr:hover {
  background-color: #1e293b !important;
}

/* Modal */
.modal-content {
  border-radius: 20px !important;
  border: none !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}
html.dark .modal-content {
  background-color: #1e293b !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;
}

/* Badges */
.badge {
  border-radius: 6px !important;
  padding: 0.4em 0.6em !important;
  font-weight: 500 !important;
  letter-spacing: 0.02em;
}

/* ════════════════════════════════════════════════════════════════════════
 * มือถือ / iPad — ขั้นพื้นฐานที่ได้ทุกหน้า (28 ก.ย. 69)
 * ════════════════════════════════════════════════════════════════════════ */

/* iPhone (Safari) ซูมหน้าจอเองเมื่อแตะช่องกรอกที่ตัวอักษรเล็กกว่า 16px และไม่ซูมกลับ
   ผู้ใช้ต้องถ่างนิ้วออกเองทุกครั้งที่กรอก — บังคับ 16px เฉพาะจอเล็กกว่า md
   (ใช้ !important เพราะคลาส text-xs/text-sm ของ Tailwind ต้องแพ้) */
@media (max-width: 767px) {
  input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):not([type="color"]),
  select,
  textarea {
    font-size: 16px !important;
  }
}

/* แตะแล้วไม่มีกรอบสีเทาค้างของ iOS · หมุนจอแล้ว iOS ไม่ขยายตัวอักษรเอง */
html {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
}

/* ใบประเมินราคา โหมดดู (/tools/price-estimate/:id) — ช่องที่ปิดอยู่ดูเป็นข้อความธรรมดาแบบเอกสาร (28 ก.ย. 69)
   ใช้ตัวเดียวกับโหมดแก้ ไม่แยกเทมเพลต กันสองหน้าหน้าตาไม่ตรงกันเวลาเพิ่มช่องใหม่ */
.est-view input:disabled:not([type="checkbox"]):not([type="radio"]),
.est-view select:disabled,
.est-view textarea:disabled {
  border-color: transparent !important;
  background: transparent !important;
  color: #0f172a !important;
  -webkit-text-fill-color: #0f172a;
  opacity: 1 !important;
  cursor: default;
  appearance: none;
  -webkit-appearance: none;
}
.est-view input:disabled::placeholder,
.est-view textarea:disabled::placeholder { color: transparent; }

/* หน้ากรอบนิ่ง (หัวอยู่กับที่ เลื่อนเฉพาะรายการ · lg:h-[calc(100dvh-61px)]) — ซ่อนแถบลิขสิทธิ์ท้ายจอบนจอคอม (2 ต.ค. 69)
   แถบนี้อยู่ใต้หน้าในกล่องเลื่อนเดียวกัน หน้าที่สูงเต็มจอแล้วจึงเลื่อนทั้งหน้าได้อีก ~69px: หัวหน้าเลื่อนหาย
   และแถบ "เลื่อนลงดูต่อ" ของคลัง BOM ถูกตัดใต้จอ (ผู้ใช้: "ET467 มี 2 บอร์ด แต่เห็น BOM เดียว") */
@media (min-width: 1024px) {
  #main-scroll-container:has([class*="lg:h-[calc(100dvh-61px)]"]) > footer { display: none; }
}




/* ── ธีม Excel ของหน้าใบเสนอราคา / ใบแจ้งหนี้ / ใบกำกับภาษี (20 ต.ค. 69) ─────────────────────
   ผู้ใช้: "UI ยังเป็นแบบกลม ๆ ขอกลิ่นอาย Excel · ระวังอย่าแตะต้องฟอร์ม"
   .xl-doc ใส่ที่กล่องหลักของหน้าสร้าง/แก้ (wizard) และแถบเครื่องมือของหน้าดูใบ
   ⚠ ทุกกฎยกเว้นแผ่นเอกสาร (QuotationPDF / InvoicePDF / TaxInvoicePDF: .break-after-page · .last-print-page · .print-area)
     ฟอร์มเอกสารและการพิมพ์ต้องเหมือนเดิมทุกจุด */
.xl-doc.bg-slate-50 { background-color: #f3f3f3 !important; }
.xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl, .rounded-2xl, .rounded-3xl, [class*="rounded-["]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px !important; }
.xl-doc :is(button, a, label).rounded-full:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px !important; }
.xl-doc :is(.shadow, .shadow-sm, .shadow-md, .shadow-lg, .shadow-xl, .shadow-2xl):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { box-shadow: 0 1px 2px rgba(0, 0, 0, .08) !important; }
.xl-doc :is(input, select, textarea):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 3px !important; border-color: #b9c4bd; }
.xl-doc :is(input, select, textarea):focus:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #217346 !important; box-shadow: 0 0 0 2px rgba(33, 115, 70, .2) !important; outline: none !important; }
.xl-doc :is(.border-slate-100, .border-slate-200, .border-gray-100, .border-gray-200):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #c8d0ca !important; }
/* สีหลัก (ดำ / น้ำเงิน / ม่วงคราม) → เขียว Excel */
.xl-doc :is(.bg-slate-900, .bg-slate-800, .bg-black, .bg-blue-600, .bg-indigo-600):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #217346 !important; }
.xl-doc :is(.hover\\:bg-slate-800, .hover\\:bg-slate-700, .hover\\:bg-blue-700, .hover\\:bg-indigo-700):hover:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #185c37 !important; }
.xl-doc :is(.text-blue-600, .text-indigo-600):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { color: #217346 !important; }
.xl-doc :is(.bg-blue-50, .bg-indigo-50):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #e3efe6 !important; }
.xl-doc :is(.border-blue-500, .border-indigo-500, .border-slate-900):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #217346 !important; }

/* แถบเครื่องมือหน้าดูใบ (ใบเสนอราคา / ใบแจ้งหนี้ / ใบกำกับ) บน iPad — เดิมบีบจนชื่อใบแตกคำละบรรทัด ปุ่มตัวหนังสือหัก
   (20 ต.ค. 69) → ให้กลุ่มขึ้นบรรทัดใหม่แทน · ชื่อและปุ่มไม่ตัดคำ · ไม่แตะแผ่นเอกสาร */
.xl-doc.no-print > div { flex-wrap: wrap; row-gap: .5rem; column-gap: .75rem; }
.xl-doc.no-print > div > div { flex-wrap: wrap; row-gap: .5rem; }
.xl-doc.no-print :is(button, a, h1, label) { white-space: nowrap; }
.xl-doc.no-print > div > div:last-child { margin-left: auto; }
.xl-doc.no-print .mr-2 { margin-right: 0 !important; }
.selection\\:bg-black *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-blue-100 *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-blue-500 *::selection{
  background-color: var(--color-primary);
}
.selection\\:bg-blue-600 *::selection{
  background-color: var(--color-primary);
}
.selection\\:bg-indigo-100 *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-slate-200 *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-slate-900 *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.selection\\:text-blue-900 *::selection{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.selection\\:text-indigo-900 *::selection{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.selection\\:text-slate-900 *::selection{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.selection\\:text-white *::selection{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.selection\\:bg-black::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-blue-100::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-blue-500::selection{
  background-color: var(--color-primary);
}
.selection\\:bg-blue-600::selection{
  background-color: var(--color-primary);
}
.selection\\:bg-indigo-100::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-slate-200::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-slate-900::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.selection\\:text-blue-900::selection{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.selection\\:text-indigo-900::selection{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.selection\\:text-slate-900::selection{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.selection\\:text-white::selection{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.file\\:mr-3::file-selector-button{
  margin-right: 0.75rem;
}
.file\\:mr-4::file-selector-button{
  margin-right: 1rem;
}
.file\\:rounded-full::file-selector-button{
  border-radius: 9999px;
}
.file\\:rounded-lg::file-selector-button{
  border-radius: 1rem;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-blue-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.file\\:bg-indigo-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.file\\:bg-slate-900::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:px-4::file-selector-button{
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-2::file-selector-button{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:text-xs::file-selector-button{
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-bold::file-selector-button{
  font-weight: 700;
}
.file\\:font-semibold::file-selector-button{
  font-weight: 600;
}
.file\\:text-blue-700::file-selector-button{
  color: var(--color-primary-hover);
}
.file\\:text-indigo-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.file\\:text-white::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:-left-3::before{
  content: var(--tw-content);
  left: -0.75rem;
}
.before\\:left-0::before{
  content: var(--tw-content);
  left: 0px;
}
.before\\:top-0::before{
  content: var(--tw-content);
  top: 0px;
}
.before\\:top-5::before{
  content: var(--tw-content);
  top: 1.25rem;
}
.before\\:h-8::before{
  content: var(--tw-content);
  height: 2rem;
}
.before\\:w-3::before{
  content: var(--tw-content);
  width: 0.75rem;
}
.before\\:w-6::before{
  content: var(--tw-content);
  width: 1.5rem;
}
.before\\:rounded-bl-lg::before{
  content: var(--tw-content);
  border-bottom-left-radius: 1rem;
}
.before\\:border-b-2::before{
  content: var(--tw-content);
  border-bottom-width: 2px;
}
.before\\:border-l-2::before{
  content: var(--tw-content);
  border-left-width: 2px;
}
.before\\:border-t-2::before{
  content: var(--tw-content);
  border-top-width: 2px;
}
.before\\:border-slate-200::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.before\\:border-slate-300::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:-bottom-2::after{
  content: var(--tw-content);
  bottom: -0.5rem;
}
.after\\:left-0::after{
  content: var(--tw-content);
  left: 0px;
}
.after\\:top-0::after{
  content: var(--tw-content);
  top: 0px;
}
.after\\:border-l-2::after{
  content: var(--tw-content);
  border-left-width: 2px;
}
.after\\:border-slate-300::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.last\\:border-0:last-child{
  border-width: 0px;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child{
  border-right-width: 0px;
}
.empty\\:hidden:empty{
  display: none;
}
.focus-within\\:border-indigo-500:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus-within\\:bg-white:focus-within{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-\\[\\#217346\\]:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 115 70 / var(--tw-ring-opacity, 1));
}
.hover\\:w-\\[268px\\]:hover{
  width: 268px;
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#217346\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(33 115 70 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.hover\\:border-amber-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.hover\\:border-black:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500:hover{
  border-color: var(--color-primary);
}
.hover\\:border-blue-600:hover{
  border-color: var(--color-primary);
}
.hover\\:border-emerald-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-500\\/30:hover{
  border-color: rgb(99 102 241 / 0.3);
}
.hover\\:border-orange-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
.hover\\:border-purple-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-700:hover{
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.hover\\:border-rose-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.hover\\:border-teal-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-violet-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.hover\\:border-white\\/30:hover{
  border-color: rgb(255 255 255 / 0.3);
}
.hover\\:\\!bg-emerald-100:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:\\!bg-rose-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1)) !important;
}
.hover\\:bg-\\[\\#000000\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#185c37\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(24 92 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a5c38\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(26 92 56 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#32b350\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(50 179 80 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#4a8a8a\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(74 138 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d5e7d9\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(213 231 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d5e8cd\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(213 232 205 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e3efe6\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(227 239 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e5e5ea\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 234 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#eef7f1\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 247 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f0f9f3\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 243 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f4f9f5\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#fce4e4\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 228 228 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50\\/50:hover{
  background-color: rgb(255 251 235 / 0.5);
}
.hover\\:bg-amber-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/80:hover{
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50\\/30:hover{
  background-color: rgb(239 246 255 / 0.3);
}
.hover\\:bg-blue-50\\/40:hover{
  background-color: rgb(239 246 255 / 0.4);
}
.hover\\:bg-blue-50\\/50:hover{
  background-color: rgb(239 246 255 / 0.5);
}
.hover\\:bg-blue-50\\/70:hover{
  background-color: rgb(239 246 255 / 0.7);
}
.hover\\:bg-blue-500:hover{
  background-color: var(--color-primary);
}
.hover\\:bg-blue-600:hover{
  background-color: var(--color-primary);
}
.hover\\:bg-blue-700:hover{
  background-color: var(--color-primary-hover);
}
.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50\\/30:hover{
  background-color: rgb(236 253 245 / 0.3);
}
.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-fuchsia-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50\\/40:hover{
  background-color: rgb(240 253 244 / 0.4);
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50\\/20:hover{
  background-color: rgb(238 242 255 / 0.2);
}
.hover\\:bg-indigo-50\\/30:hover{
  background-color: rgb(238 242 255 / 0.3);
}
.hover\\:bg-indigo-50\\/40:hover{
  background-color: rgb(238 242 255 / 0.4);
}
.hover\\:bg-indigo-50\\/50:hover{
  background-color: rgb(238 242 255 / 0.5);
}
.hover\\:bg-indigo-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sky-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100\\/50:hover{
  background-color: rgb(241 245 249 / 0.5);
}
.hover\\:bg-slate-100\\/80:hover{
  background-color: rgb(241 245 249 / 0.8);
}
.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200\\/60:hover{
  background-color: rgb(226 232 240 / 0.6);
}
.hover\\:bg-slate-200\\/70:hover{
  background-color: rgb(226 232 240 / 0.7);
}
.hover\\:bg-slate-200\\/80:hover{
  background-color: rgb(226 232 240 / 0.8);
}
.hover\\:bg-slate-200\\/90:hover{
  background-color: rgb(226 232 240 / 0.9);
}
.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/30:hover{
  background-color: rgb(245 245 247 / 0.3);
}
.hover\\:bg-slate-50\\/50:hover{
  background-color: rgb(245 245 247 / 0.5);
}
.hover\\:bg-slate-50\\/60:hover{
  background-color: rgb(245 245 247 / 0.6);
}
.hover\\:bg-slate-50\\/70:hover{
  background-color: rgb(245 245 247 / 0.7);
}
.hover\\:bg-slate-50\\/80:hover{
  background-color: rgb(245 245 247 / 0.8);
}
.hover\\:bg-slate-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}
.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}
.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}
.hover\\:bg-yellow-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}
.hover\\:from-blue-600:hover{
  --tw-gradient-from: var(--color-primary) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-blue-700:hover{
  --tw-gradient-from: var(--color-primary-hover) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-emerald-700:hover{
  --tw-gradient-from: #047857 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 120 87 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-indigo-700:hover{
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-indigo-600:hover{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.hover\\:to-indigo-700:hover{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.hover\\:to-teal-700:hover{
  --tw-gradient-to: #0f766e var(--tw-gradient-to-position);
}
.hover\\:to-violet-700:hover{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}
.hover\\:text-\\[\\#217346\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(33 115 70 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-200:hover{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-300:hover{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-400:hover{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-500:hover{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-800:hover{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover{
  color: var(--color-primary);
}
.hover\\:text-blue-600:hover{
  color: var(--color-primary);
}
.hover\\:text-blue-700:hover{
  color: var(--color-primary-hover);
}
.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-900:hover{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-800:hover{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-900:hover{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-950:hover{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-800:hover{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-500:hover{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-500:hover{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-800:hover{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-300:hover{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-500:hover{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-950:hover{
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.hover\\:text-teal-700:hover{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:no-underline:hover{
  text-decoration-line: none;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:opacity-85:hover{
  opacity: 0.85;
}
.hover\\:shadow:hover{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-2xl:hover{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_8px_20px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]:hover{
  --tw-shadow: 0 8px 20px rgb(0,0,0,0.06);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-black\\/20:hover{
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-200:hover{
  --tw-shadow-color: #bfdbfe;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-emerald-200:hover{
  --tw-shadow-color: #a7f3d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-200:hover{
  --tw-shadow-color: #c7d2fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-2:hover{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-emerald-400:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-green-300:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-indigo-300:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-indigo-400:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-rose-200:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-slate-300:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-slate-400:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(148 163 184 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-slate-900:hover{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.hover\\:brightness-110:hover{
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:brightness-95:hover{
  --tw-brightness: brightness(.95);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:file\\:bg-blue-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-indigo-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.focus\\:border-\\[\\#217346\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(33 115 70 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[var\\(--color-primary\\)\\]:focus{
  border-color: var(--color-primary);
}
.focus\\:border-amber-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.focus\\:border-black:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus{
  border-color: var(--color-primary);
}
.focus\\:border-blue-600:focus{
  border-color: var(--color-primary);
}
.focus\\:border-emerald-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-500\\/50:focus{
  border-color: rgb(16 185 129 / 0.5);
}
.focus\\:border-emerald-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity, 1));
}
.focus\\:border-green-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.focus\\:border-orange-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.focus\\:border-purple-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.focus\\:border-rose-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.focus\\:border-sky-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-900:focus{
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.focus\\:border-teal-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1));
}
.focus\\:border-violet-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-yellow-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1));
}
.focus\\:bg-indigo-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-slate-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:shadow-lg:focus{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[6px\\]:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(6px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[8px\\]:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-inset:focus{
  --tw-ring-inset: inset;
}
.focus\\:ring-\\[\\#217346\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 115 70 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#217346\\]\\/20:focus{
  --tw-ring-color: rgb(33 115 70 / 0.2);
}
.focus\\:ring-black:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-black\\/5:focus{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-50:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 246 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-color: var(--color-primary);
}
.focus\\:ring-emerald-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-500\\/10:focus{
  --tw-ring-color: rgb(16 185 129 / 0.1);
}
.focus\\:ring-emerald-500\\/20:focus{
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
.focus\\:ring-emerald-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 150 105 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-600\\/10:focus{
  --tw-ring-color: rgb(5 150 105 / 0.1);
}
.focus\\:ring-emerald-600\\/20:focus{
  --tw-ring-color: rgb(5 150 105 / 0.2);
}
.focus\\:ring-green-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 222 128 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-700\\/20:focus{
  --tw-ring-color: rgb(21 128 61 / 0.2);
}
.focus\\:ring-indigo-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-50:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500\\/10:focus{
  --tw-ring-color: rgb(99 102 241 / 0.1);
}
.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
.focus\\:ring-indigo-500\\/50:focus{
  --tw-ring-color: rgb(99 102 241 / 0.5);
}
.focus\\:ring-indigo-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-orange-500\\/10:focus{
  --tw-ring-color: rgb(249 115 22 / 0.1);
}
.focus\\:ring-pink-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 168 212 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-500\\/10:focus{
  --tw-ring-color: rgb(168 85 247 / 0.1);
}
.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-rose-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-rose-50:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 241 242 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-sky-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-slate-900:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-slate-900\\/10:focus{
  --tw-ring-color: rgb(15 23 42 / 0.1);
}
.focus\\:ring-teal-500\\/10:focus{
  --tw-ring-color: rgb(20 184 166 / 0.1);
}
.focus\\:ring-violet-500\\/20:focus{
  --tw-ring-color: rgb(139 92 246 / 0.2);
}
.focus\\:ring-violet-700:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(109 40 217 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:outline:focus-visible{
  outline-style: solid;
}
.focus-visible\\:outline-2:focus-visible{
  outline-width: 2px;
}
.focus-visible\\:outline-\\[\\#3b6cf6\\]:focus-visible{
  outline-color: #3b6cf6;
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-4:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-amber-500\\/20:focus-visible{
  --tw-ring-color: rgb(245 158 11 / 0.2);
}
.focus-visible\\:ring-emerald-600:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 150 105 / var(--tw-ring-opacity, 1));
}
.active\\:translate-y-0:active{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-blue-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.active\\:bg-indigo-50\\/40:active{
  background-color: rgb(238 242 255 / 0.4);
}
.active\\:bg-rose-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.active\\:bg-slate-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-default:disabled{
  cursor: default;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:border-slate-200:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.disabled\\:border-transparent:disabled{
  border-color: transparent;
}
.disabled\\:bg-indigo-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-200:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-slate-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 247 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-transparent:disabled{
  background-color: transparent;
}
.disabled\\:text-slate-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-500:disabled{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-600:disabled{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-700:disabled{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.disabled\\:text-slate-800:disabled{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-20:disabled{
  opacity: 0.2;
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}
.disabled\\:shadow-none:disabled{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:ring-0:disabled{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.disabled\\:hover\\:bg-white:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.disabled\\:active\\:scale-100:active:disabled{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:focus-within .group-focus-within\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.group:focus-within .group-focus-within\\:text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:block{
  display: block;
}
.group:hover .group-hover\\:flex{
  display: flex;
}
.group:hover .group-hover\\:hidden{
  display: none;
}
.group:hover .group-hover\\:-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-6{
  --tw-rotate: 6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group\\/thumb:hover .group-hover\\/thumb\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:justify-start{
  justify-content: flex-start;
}
.group:hover .group-hover\\:border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-zinc-500{
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-indigo-50\\/40{
  background-color: rgb(238 242 255 / 0.4);
}
.group:hover .group-hover\\:bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.group\\/ref:hover .group-hover\\/ref\\:text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-500{
  color: var(--color-primary);
}
.group:hover .group-hover\\:text-blue-600{
  color: var(--color-primary);
}
.group:hover .group-hover\\:text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:underline{
  text-decoration-line: underline;
}
.group\\/ref:hover .group-hover\\/ref\\:opacity-100{
  opacity: 1;
}
.group\\/thumb:hover .group-hover\\/thumb\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-20{
  opacity: 0.2;
}
.group:hover .group-hover\\:shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (prefers-reduced-motion: no-preference){

  .group:hover .motion-safe\\:group-hover\\:translate-x-1{
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (prefers-reduced-motion: reduce){

  .motion-reduce\\:animate-none{
    animation: none;
  }
}
.dark\\:divide-white\\/5:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.05);
}
.dark\\:divide-zinc-700:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-zinc-800:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-zinc-800\\/50:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(39 39 42 / 0.5);
}
.dark\\:border-\\[\\#38383a\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(56 56 58 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#38383a\\]\\/50:is(.dark *){
  border-color: rgb(56 56 58 / 0.5);
}
.dark\\:border-amber-500\\/20:is(.dark *){
  border-color: rgb(245 158 11 / 0.2);
}
.dark\\:border-amber-800\\/50:is(.dark *){
  border-color: rgb(146 64 14 / 0.5);
}
.dark\\:border-blue-500:is(.dark *){
  border-color: var(--color-primary);
}
.dark\\:border-blue-800\\/30:is(.dark *){
  border-color: rgb(30 64 175 / 0.3);
}
.dark\\:border-blue-800\\/50:is(.dark *){
  border-color: rgb(30 64 175 / 0.5);
}
.dark\\:border-emerald-500\\/20:is(.dark *){
  border-color: rgb(16 185 129 / 0.2);
}
.dark\\:border-emerald-800\\/30:is(.dark *){
  border-color: rgb(6 95 70 / 0.3);
}
.dark\\:border-emerald-800\\/50:is(.dark *){
  border-color: rgb(6 95 70 / 0.5);
}
.dark\\:border-indigo-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.dark\\:border-indigo-800\\/50:is(.dark *){
  border-color: rgb(55 48 163 / 0.5);
}
.dark\\:border-indigo-900\\/40:is(.dark *){
  border-color: rgb(49 46 129 / 0.4);
}
.dark\\:border-rose-800\\/50:is(.dark *){
  border-color: rgb(159 18 57 / 0.5);
}
.dark\\:border-sky-800\\/50:is(.dark *){
  border-color: rgb(7 89 133 / 0.5);
}
.dark\\:border-slate-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}
.dark\\:border-white\\/15:is(.dark *){
  border-color: rgb(255 255 255 / 0.15);
}
.dark\\:border-white\\/20:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}
.dark\\:border-white\\/5:is(.dark *){
  border-color: rgb(255 255 255 / 0.05);
}
.dark\\:border-zinc-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity, 1));
}
.dark\\:border-zinc-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.dark\\:border-zinc-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}
.dark\\:border-b-zinc-900:is(.dark *){
  --tw-border-opacity: 1;
  border-bottom-color: rgb(28 28 30 / var(--tw-border-opacity, 1));
}
.dark\\:bg-\\[\\#09090b\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#0a0a0a\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#111111\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1c1c1e\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1c1c1e\\]\\/80:is(.dark *){
  background-color: rgb(28 28 30 / 0.8);
}
.dark\\:bg-\\[\\#1c1c1e\\]\\/90:is(.dark *){
  background-color: rgb(28 28 30 / 0.9);
}
.dark\\:bg-\\[\\#2c2c2e\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(44 44 46 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#2c2c2e\\]\\/90:is(.dark *){
  background-color: rgb(44 44 46 / 0.9);
}
.dark\\:bg-\\[\\#3b6cf6\\]\\/15:is(.dark *){
  background-color: rgb(59 108 246 / 0.15);
}
.dark\\:bg-amber-500\\/10:is(.dark *){
  background-color: rgb(245 158 11 / 0.1);
}
.dark\\:bg-amber-500\\/15:is(.dark *){
  background-color: rgb(245 158 11 / 0.15);
}
.dark\\:bg-amber-900\\/30:is(.dark *){
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:bg-amber-950\\/30:is(.dark *){
  background-color: rgb(69 26 3 / 0.3);
}
.dark\\:bg-amber-950\\/40:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}
.dark\\:bg-black:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-black\\/20:is(.dark *){
  background-color: rgb(0 0 0 / 0.2);
}
.dark\\:bg-black\\/30:is(.dark *){
  background-color: rgb(0 0 0 / 0.3);
}
.dark\\:bg-black\\/40:is(.dark *){
  background-color: rgb(0 0 0 / 0.4);
}
.dark\\:bg-black\\/50:is(.dark *){
  background-color: rgb(0 0 0 / 0.5);
}
.dark\\:bg-blue-500:is(.dark *){
  background-color: var(--color-primary);
}
.dark\\:bg-blue-900\\/10:is(.dark *){
  background-color: rgb(30 58 138 / 0.1);
}
.dark\\:bg-blue-900\\/20:is(.dark *){
  background-color: rgb(30 58 138 / 0.2);
}
.dark\\:bg-blue-900\\/30:is(.dark *){
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:bg-blue-900\\/50:is(.dark *){
  background-color: rgb(30 58 138 / 0.5);
}
.dark\\:bg-emerald-500\\/10:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}
.dark\\:bg-emerald-500\\/15:is(.dark *){
  background-color: rgb(16 185 129 / 0.15);
}
.dark\\:bg-emerald-500\\/40:is(.dark *){
  background-color: rgb(16 185 129 / 0.4);
}
.dark\\:bg-emerald-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-900\\/20:is(.dark *){
  background-color: rgb(6 78 59 / 0.2);
}
.dark\\:bg-emerald-900\\/30:is(.dark *){
  background-color: rgb(6 78 59 / 0.3);
}
.dark\\:bg-emerald-950\\/30:is(.dark *){
  background-color: rgb(2 44 34 / 0.3);
}
.dark\\:bg-emerald-950\\/50:is(.dark *){
  background-color: rgb(2 44 34 / 0.5);
}
.dark\\:bg-emerald-950\\/60:is(.dark *){
  background-color: rgb(2 44 34 / 0.6);
}
.dark\\:bg-green-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-900\\/30:is(.dark *){
  background-color: rgb(49 46 129 / 0.3);
}
.dark\\:bg-indigo-950\\/30:is(.dark *){
  background-color: rgb(30 27 75 / 0.3);
}
.dark\\:bg-indigo-950\\/50:is(.dark *){
  background-color: rgb(30 27 75 / 0.5);
}
.dark\\:bg-red-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-900\\/30:is(.dark *){
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:bg-red-950\\/40:is(.dark *){
  background-color: rgb(69 10 10 / 0.4);
}
.dark\\:bg-rose-500\\/10:is(.dark *){
  background-color: rgb(244 63 94 / 0.1);
}
.dark\\:bg-rose-500\\/15:is(.dark *){
  background-color: rgb(244 63 94 / 0.15);
}
.dark\\:bg-rose-950\\/50:is(.dark *){
  background-color: rgb(76 5 25 / 0.5);
}
.dark\\:bg-sky-900\\/20:is(.dark *){
  background-color: rgb(12 74 110 / 0.2);
}
.dark\\:bg-violet-500\\/10:is(.dark *){
  background-color: rgb(139 92 246 / 0.1);
}
.dark\\:bg-violet-500\\/15:is(.dark *){
  background-color: rgb(139 92 246 / 0.15);
}
.dark\\:bg-white:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:bg-white\\/\\[0\\.02\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.02);
}
.dark\\:bg-white\\/\\[0\\.03\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}
.dark\\:bg-yellow-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-800\\/30:is(.dark *){
  background-color: rgb(39 39 42 / 0.3);
}
.dark\\:bg-zinc-800\\/50:is(.dark *){
  background-color: rgb(39 39 42 / 0.5);
}
.dark\\:bg-zinc-800\\/80:is(.dark *){
  background-color: rgb(39 39 42 / 0.8);
}
.dark\\:bg-zinc-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-900\\/30:is(.dark *){
  background-color: rgb(28 28 30 / 0.3);
}
.dark\\:bg-zinc-900\\/40:is(.dark *){
  background-color: rgb(28 28 30 / 0.4);
}
.dark\\:bg-zinc-900\\/50:is(.dark *){
  background-color: rgb(28 28 30 / 0.5);
}
.dark\\:bg-zinc-950:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-zinc-950\\/50:is(.dark *){
  background-color: rgb(0 0 0 / 0.5);
}
.dark\\:from-amber-950\\/50:is(.dark *){
  --tw-gradient-from: rgb(69 26 3 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(69 26 3 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-black:is(.dark *){
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-blue-950\\/50:is(.dark *){
  --tw-gradient-from: rgb(23 37 84 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 37 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-emerald-950\\/50:is(.dark *){
  --tw-gradient-from: rgb(2 44 34 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 44 34 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-rose-950\\/50:is(.dark *){
  --tw-gradient-from: rgb(76 5 25 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(76 5 25 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:from-zinc-800:is(.dark *){
  --tw-gradient-from: #27272a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(39 39 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:via-zinc-950:is(.dark *){
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #000000 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:to-amber-900\\/30:is(.dark *){
  --tw-gradient-to: rgb(120 53 15 / 0.3) var(--tw-gradient-to-position);
}
.dark\\:to-black:is(.dark *){
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.dark\\:to-blue-900\\/30:is(.dark *){
  --tw-gradient-to: rgb(30 58 138 / 0.3) var(--tw-gradient-to-position);
}
.dark\\:to-emerald-900\\/30:is(.dark *){
  --tw-gradient-to: rgb(6 78 59 / 0.3) var(--tw-gradient-to-position);
}
.dark\\:to-rose-900\\/30:is(.dark *){
  --tw-gradient-to: rgb(136 19 55 / 0.3) var(--tw-gradient-to-position);
}
.dark\\:to-zinc-700:is(.dark *){
  --tw-gradient-to: #3f3f46 var(--tw-gradient-to-position);
}
.dark\\:to-zinc-900:is(.dark *){
  --tw-gradient-to: #1c1c1e var(--tw-gradient-to-position);
}
.dark\\:text-\\[\\#a9c0ff\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(169 192 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#f5f5f7\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(245 245 247 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-200\\/90:is(.dark *){
  color: rgb(253 230 138 / 0.9);
}
.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-black:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-400\\/70:is(.dark *){
  color: rgb(56 189 248 / 0.7);
}
.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.dark\\:text-violet-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-violet-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-white\\/70:is(.dark *){
  color: rgb(255 255 255 / 0.7);
}
.dark\\:text-white\\/90:is(.dark *){
  color: rgb(255 255 255 / 0.9);
}
.dark\\:text-zinc-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.dark\\:text-zinc-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.dark\\:text-zinc-700:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.dark\\:text-zinc-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder-zinc-600:is(.dark *)::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(82 82 91 / var(--tw-placeholder-opacity, 1));
}
.dark\\:shadow-\\[0_0_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]:is(.dark *){
  --tw-shadow: 0 0 40px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-\\[0_0_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]:is(.dark *){
  --tw-shadow: 0 0 50px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 0 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-\\[0_10px_40px_-10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]:is(.dark *){
  --tw-shadow: 0 10px 40px -10px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 10px 40px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]:is(.dark *){
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:ring-amber-500\\/50:is(.dark *){
  --tw-ring-color: rgb(245 158 11 / 0.5);
}
.dark\\:ring-rose-500\\/50:is(.dark *){
  --tw-ring-color: rgb(244 63 94 / 0.5);
}
.dark\\:ring-violet-500\\/50:is(.dark *){
  --tw-ring-color: rgb(139 92 246 / 0.5);
}
.dark\\:ring-zinc-800:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(39 39 42 / var(--tw-ring-opacity, 1));
}
.dark\\:selection\\:bg-slate-700 *:is(.dark *)::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:selection\\:bg-slate-700:is(.dark *)::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:file\\:bg-blue-900\\/30:is(.dark *)::file-selector-button{
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:file\\:text-blue-400:is(.dark *)::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder\\:text-gray-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder\\:text-slate-500:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder\\:text-slate-600:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:border-blue-500:hover:is(.dark *){
  border-color: var(--color-primary);
}
.dark\\:hover\\:border-white\\/20:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}
.dark\\:hover\\:border-zinc-700:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#3a3a3c\\]:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 60 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-amber-500\\/10:hover:is(.dark *){
  background-color: rgb(245 158 11 / 0.1);
}
.dark\\:hover\\:bg-black\\/20:hover:is(.dark *){
  background-color: rgb(0 0 0 / 0.2);
}
.dark\\:hover\\:bg-blue-600:hover:is(.dark *){
  background-color: var(--color-primary);
}
.dark\\:hover\\:bg-blue-900\\/10:hover:is(.dark *){
  background-color: rgb(30 58 138 / 0.1);
}
.dark\\:hover\\:bg-blue-900\\/40:hover:is(.dark *){
  background-color: rgb(30 58 138 / 0.4);
}
.dark\\:hover\\:bg-emerald-500\\/10:hover:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}
.dark\\:hover\\:bg-emerald-900\\/10:hover:is(.dark *){
  background-color: rgb(6 78 59 / 0.1);
}
.dark\\:hover\\:bg-gray-200:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:hover\\:bg-red-900\\/50:hover:is(.dark *){
  background-color: rgb(127 29 29 / 0.5);
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-white:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:hover\\:bg-white\\/\\[0\\.02\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.02);
}
.dark\\:hover\\:bg-white\\/\\[0\\.06\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.06);
}
.dark\\:hover\\:bg-yellow-500:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-zinc-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-zinc-700\\/50:hover:is(.dark *){
  background-color: rgb(63 63 70 / 0.5);
}
.dark\\:hover\\:bg-zinc-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-zinc-800\\/20:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.2);
}
.dark\\:hover\\:bg-zinc-800\\/50:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.5);
}
.dark\\:hover\\:bg-zinc-800\\/60:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.6);
}
.dark\\:hover\\:bg-zinc-900:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-zinc-900\\/50:hover:is(.dark *){
  background-color: rgb(28 28 30 / 0.5);
}
.dark\\:hover\\:text-blue-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:file\\:bg-blue-900\\/50:is(.dark *)::file-selector-button:hover{
  background-color: rgb(30 58 138 / 0.5);
}
.dark\\:focus\\:border-slate-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:ring-indigo-950:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 27 75 / var(--tw-ring-opacity, 1));
}
.dark\\:disabled\\:bg-slate-800:disabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:disabled\\:text-slate-400:disabled:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 1024px){

  .max-lg\\:sticky{
    position: sticky;
  }

  .max-lg\\:bottom-0{
    bottom: 0px;
  }

  .max-lg\\:z-20{
    z-index: 20;
  }

  .max-lg\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .max-lg\\:border-t{
    border-top-width: 1px;
  }

  .max-lg\\:border-slate-200{
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  }

  .max-lg\\:bg-white\\/95{
    background-color: rgb(255 255 255 / 0.95);
  }

  .max-lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .max-lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .max-lg\\:backdrop-blur{
    --tw-backdrop-blur: blur(8px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }
}
@media not all and (min-width: 640px){

  .max-sm\\:w-full{
    width: 100%;
  }
}
@media (min-width: 640px){

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .sm\\:ml-\\[70px\\]{
    margin-left: 70px;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mr-2{
    margin-right: 0.5rem;
  }

  .sm\\:mr-auto{
    margin-right: auto;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline-block{
    display: inline-block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-\\[calc\\(100dvh_-_7rem\\)\\]{
    height: calc(100dvh - 7rem);
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:max-h-\\[95vh\\]{
    max-height: 95vh;
  }

  .sm\\:max-h-\\[calc\\(90vh-150px\\)\\]{
    max-height: calc(90vh - 150px);
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-2\\/3{
    width: 66.666667%;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-52{
    width: 13rem;
  }

  .sm\\:w-56{
    width: 14rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-72{
    width: 18rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-96{
    width: 24rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-\\[11rem\\]{
    max-width: 11rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1fr_11rem\\]{
    grid-template-columns: 1fr 11rem;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1\\.6fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1.6fr) minmax(0,1fr);
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_10rem_auto\\]{
    grid-template-columns: minmax(0,1fr) 10rem auto;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_14rem_6rem_7\\.5rem\\]{
    grid-template-columns: minmax(0,1fr) 14rem 6rem 7.5rem;
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)_auto\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1fr) auto;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:gap-8{
    gap: 2rem;
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .sm\\:self-center{
    align-self: center;
  }

  .sm\\:rounded-md{
    border-radius: 0.375rem;
  }

  .sm\\:p-0{
    padding: 0px;
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:p-\\[1\\.5rem\\]{
    padding: 1.5rem;
  }

  .sm\\:p-\\[1rem\\]{
    padding: 1rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pt-12{
    padding-top: 3rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .sm\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 768px){

  .md\\:sticky{
    position: sticky;
  }

  .md\\:bottom-0{
    bottom: 0px;
  }

  .md\\:left-auto{
    left: auto;
  }

  .md\\:right-6{
    right: 1.5rem;
  }

  .md\\:order-1{
    order: 1;
  }

  .md\\:order-2{
    order: 2;
  }

  .md\\:order-last{
    order: 9999;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .md\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .md\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .md\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .md\\:-mt-4{
    margin-top: -1rem;
  }

  .md\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .md\\:mb-16{
    margin-bottom: 4rem;
  }

  .md\\:ml-0{
    margin-left: 0px;
  }

  .md\\:ml-auto{
    margin-left: auto;
  }

  .md\\:mr-1{
    margin-right: 0.25rem;
  }

  .md\\:mr-auto{
    margin-right: auto;
  }

  .md\\:mt-0{
    margin-top: 0px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:table{
    display: table;
  }

  .md\\:grid{
    display: grid;
  }

  .md\\:inline-grid{
    display: inline-grid;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-11{
    height: 2.75rem;
  }

  .md\\:h-12{
    height: 3rem;
  }

  .md\\:h-14{
    height: 3.5rem;
  }

  .md\\:h-16{
    height: 4rem;
  }

  .md\\:h-20{
    height: 5rem;
  }

  .md\\:h-24{
    height: 6rem;
  }

  .md\\:h-28{
    height: 7rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:min-h-0{
    min-height: 0px;
  }

  .md\\:min-h-\\[2\\.5rem\\]{
    min-height: 2.5rem;
  }

  .md\\:w-1\\/4{
    width: 25%;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-11{
    width: 2.75rem;
  }

  .md\\:w-20{
    width: 5rem;
  }

  .md\\:w-24{
    width: 6rem;
  }

  .md\\:w-28{
    width: 7rem;
  }

  .md\\:w-3\\/4{
    width: 75%;
  }

  .md\\:w-32{
    width: 8rem;
  }

  .md\\:w-36{
    width: 9rem;
  }

  .md\\:w-40{
    width: 10rem;
  }

  .md\\:w-44{
    width: 11rem;
  }

  .md\\:w-56{
    width: 14rem;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:w-72{
    width: 18rem;
  }

  .md\\:w-8{
    width: 2rem;
  }

  .md\\:w-80{
    width: 20rem;
  }

  .md\\:w-96{
    width: 24rem;
  }

  .md\\:w-\\[100px\\]{
    width: 100px;
  }

  .md\\:w-\\[160px\\]{
    width: 160px;
  }

  .md\\:w-\\[28rem\\]{
    width: 28rem;
  }

  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }

  .md\\:w-\\[80px\\]{
    width: 80px;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:min-w-\\[14rem\\]{
    min-width: 14rem;
  }

  .md\\:min-w-\\[220px\\]{
    min-width: 220px;
  }

  .md\\:min-w-\\[6\\.5rem\\]{
    min-width: 6.5rem;
  }

  .md\\:max-w-\\[300px\\]{
    max-width: 300px;
  }

  .md\\:max-w-lg{
    max-width: 32rem;
  }

  .md\\:max-w-md{
    max-width: 28rem;
  }

  .md\\:max-w-xl{
    max-width: 36rem;
  }

  .md\\:flex-1{
    flex: 1 1;
  }

  .md\\:flex-none{
    flex: none;
  }

  .md\\:shrink-0{
    flex-shrink: 0;
  }

  .md\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[10rem_14rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 10rem 14rem minmax(0,1fr);
  }

  .md\\:grid-cols-\\[14rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 14rem minmax(0,1fr);
  }

  .md\\:grid-cols-\\[1fr_auto_1fr\\]{
    grid-template-columns: 1fr auto 1fr;
  }

  .md\\:grid-cols-\\[6rem_minmax\\(0\\2c 1fr\\)_2\\.75rem\\]{
    grid-template-columns: 6rem minmax(0,1fr) 2.75rem;
  }

  .md\\:grid-cols-\\[9rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 9rem minmax(0,1fr);
  }

  .md\\:grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: auto minmax(0,1fr);
  }

  .md\\:grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)_auto\\]{
    grid-template-columns: auto minmax(0,1fr) auto;
  }

  .md\\:grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)_auto_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: auto minmax(0,1fr) auto minmax(0,1fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_11rem_auto\\]{
    grid-template-columns: minmax(0,1fr) 11rem auto;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_12rem_18rem_auto\\]{
    grid-template-columns: minmax(0,1fr) 12rem 18rem auto;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_9rem_6\\.5rem_8\\.5rem_8\\.5rem\\]{
    grid-template-columns: minmax(0,1fr) 9rem 6.5rem 8.5rem 8.5rem;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1fr) auto minmax(0,1fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.2fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1.2fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.4fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1.4fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,1fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 2fr\\)\\]{
    grid-template-columns: minmax(0,1fr) minmax(0,2fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 2fr\\)_8rem_minmax\\(0\\2c 2fr\\)\\]{
    grid-template-columns: minmax(0,2fr) 8rem minmax(0,2fr);
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 2fr\\)_minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 2fr\\)_auto\\]{
    grid-template-columns: minmax(0,2fr) minmax(0,1fr) minmax(0,2fr) auto;
  }

  .md\\:grid-cols-\\[minmax\\(0\\2c 2fr\\)_minmax\\(0\\2c 2fr\\)_auto_minmax\\(0\\2c 2fr\\)_auto\\]{
    grid-template-columns: minmax(0,2fr) minmax(0,2fr) auto minmax(0,2fr) auto;
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-col{
    flex-direction: column;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:items-baseline{
    align-items: baseline;
  }

  .md\\:items-stretch{
    align-items: stretch;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-center{
    justify-content: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-10{
    gap: 2.5rem;
  }

  .md\\:gap-2{
    gap: 0.5rem;
  }

  .md\\:gap-3{
    gap: 0.75rem;
  }

  .md\\:gap-4{
    gap: 1rem;
  }

  .md\\:gap-5{
    gap: 1.25rem;
  }

  .md\\:gap-6{
    gap: 1.5rem;
  }

  .md\\:gap-8{
    gap: 2rem;
  }

  .md\\:gap-x-3{
    column-gap: 0.75rem;
  }

  .md\\:gap-x-6{
    column-gap: 1.5rem;
  }

  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .md\\:self-auto{
    align-self: auto;
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:overflow-visible{
    overflow: visible;
  }

  .md\\:overflow-y-auto{
    overflow-y: auto;
  }

  .md\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .md\\:whitespace-nowrap{
    white-space: nowrap;
  }

  .md\\:rounded-2xl{
    border-radius: 1.5rem;
  }

  .md\\:border{
    border-width: 1px;
  }

  .md\\:border-b-0{
    border-bottom-width: 0px;
  }

  .md\\:border-l-\\[1px\\]{
    border-left-width: 1px;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-r-0{
    border-right-width: 0px;
  }

  .md\\:border-t-0{
    border-top-width: 0px;
  }

  .md\\:border-slate-200\\/60{
    border-color: rgb(226 232 240 / 0.6);
  }

  .md\\:border-slate-300{
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  }

  .md\\:bg-\\[\\#fdfdfd\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(253 253 253 / var(--tw-bg-opacity, 1));
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-14{
    padding: 3.5rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:p-5{
    padding: 1.25rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pb-0{
    padding-bottom: 0px;
  }

  .md\\:pb-28{
    padding-bottom: 7rem;
  }

  .md\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .md\\:pb-8{
    padding-bottom: 2rem;
  }

  .md\\:pr-0{
    padding-right: 0px;
  }

  .md\\:pr-10{
    padding-right: 2.5rem;
  }

  .md\\:pr-6{
    padding-right: 1.5rem;
  }

  .md\\:pt-0{
    padding-top: 0px;
  }

  .md\\:pt-10{
    padding-top: 2.5rem;
  }

  .md\\:pt-2\\.5{
    padding-top: 0.625rem;
  }

  .md\\:pt-4{
    padding-top: 1rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-right{
    text-align: right;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .md\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .md\\:text-\\[14px\\]{
    font-size: 14px;
  }

  .md\\:text-\\[20px\\]{
    font-size: 20px;
  }

  .md\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .md\\:opacity-0{
    opacity: 0;
  }

  .md\\:shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .group\\/msg:hover .md\\:group-hover\\/msg\\:opacity-100{
    opacity: 1;
  }
}
@media (min-width: 1024px){

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:top-0{
    top: 0px;
  }

  .lg\\:top-3{
    top: 0.75rem;
  }

  .lg\\:top-4{
    top: 1rem;
  }

  .lg\\:order-1{
    order: 1;
  }

  .lg\\:order-2{
    order: 2;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .lg\\:col-start-1{
    grid-column-start: 1;
  }

  .lg\\:col-start-2{
    grid-column-start: 2;
  }

  .lg\\:row-start-1{
    grid-row-start: 1;
  }

  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .lg\\:ml-auto{
    margin-left: auto;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-\\[calc\\(100dvh-61px\\)\\]{
    height: calc(100dvh - 61px);
  }

  .lg\\:h-\\[calc\\(100dvh_-_8rem\\)\\]{
    height: calc(100dvh - 8rem);
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:max-h-\\[14rem\\]{
    max-height: 14rem;
  }

  .lg\\:max-h-full{
    max-height: 100%;
  }

  .lg\\:max-h-none{
    max-height: none;
  }

  .lg\\:min-h-0{
    min-height: 0px;
  }

  .lg\\:w-1\\/2{
    width: 50%;
  }

  .lg\\:w-72{
    width: 18rem;
  }

  .lg\\:w-80{
    width: 20rem;
  }

  .lg\\:w-96{
    width: 24rem;
  }

  .lg\\:w-\\[34rem\\]{
    width: 34rem;
  }

  .lg\\:w-\\[350px\\]{
    width: 350px;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:flex-1{
    flex: 1 1;
  }

  .lg\\:flex-none{
    flex: none;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[16rem_1fr\\]{
    grid-template-columns: 16rem 1fr;
  }

  .lg\\:grid-cols-\\[18rem_1fr\\]{
    grid-template-columns: 18rem 1fr;
  }

  .lg\\:grid-cols-\\[18rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 18rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[19rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 19rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[1fr_22rem\\]{
    grid-template-columns: 1fr 22rem;
  }

  .lg\\:grid-cols-\\[20rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 20rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[21rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 21rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[22rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 22rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[310px_1fr\\]{
    grid-template-columns: 310px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_22rem\\]{
    grid-template-columns: minmax(0,1fr) 22rem;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_24rem\\]{
    grid-template-columns: minmax(0,1fr) 24rem;
  }

  .lg\\:grid-rows-\\[minmax\\(0\\2c 1fr\\)\\]{
    grid-template-rows: minmax(0,1fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-3{
    gap: 0.75rem;
  }

  .lg\\:gap-4{
    gap: 1rem;
  }

  .lg\\:gap-5{
    gap: 1.25rem;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:gap-\\[1rem\\]{
    gap: 1rem;
  }

  .lg\\:gap-x-6{
    column-gap: 1.5rem;
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-visible{
    overflow: visible;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:border-slate-300{
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:p-16{
    padding: 4rem;
  }

  .lg\\:p-6{
    padding: 1.5rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:p-\\[2rem\\]{
    padding: 2rem;
  }

  .lg\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pb-20{
    padding-bottom: 5rem;
  }

  .lg\\:pb-4{
    padding-bottom: 1rem;
  }

  .lg\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .lg\\:pl-5{
    padding-left: 1.25rem;
  }

  .lg\\:pr-1{
    padding-right: 0.25rem;
  }

  .lg\\:text-left{
    text-align: left;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:opacity-0{
    opacity: 0;
  }

  .group:hover .lg\\:group-hover\\:opacity-100{
    opacity: 1;
  }
}
@media (min-width: 1280px){

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:top-4{
    top: 1rem;
  }

  .xl\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:grid{
    display: grid;
  }

  .xl\\:min-h-0{
    min-height: 0px;
  }

  .xl\\:w-60{
    width: 15rem;
  }

  .xl\\:w-72{
    width: 18rem;
  }

  .xl\\:w-80{
    width: 20rem;
  }

  .xl\\:w-\\[140px\\]{
    width: 140px;
  }

  .xl\\:w-\\[200px\\]{
    width: 200px;
  }

  .xl\\:w-auto{
    width: auto;
  }

  .xl\\:max-w-md{
    max-width: 28rem;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1fr_22rem\\]{
    grid-template-columns: 1fr 22rem;
  }

  .xl\\:grid-cols-\\[28rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 28rem minmax(0,1fr);
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_18rem\\]{
    grid-template-columns: minmax(0,1fr) 18rem;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_20rem\\]{
    grid-template-columns: minmax(0,1fr) 20rem;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_26rem\\]{
    grid-template-columns: minmax(0,1fr) 26rem;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 3fr\\)_minmax\\(0\\2c 2fr\\)\\]{
    grid-template-columns: minmax(0,3fr) minmax(0,2fr);
  }

  .xl\\:grid-rows-\\[minmax\\(0\\2c 1fr\\)\\]{
    grid-template-rows: minmax(0,1fr);
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:items-start{
    align-items: flex-start;
  }

  .xl\\:items-end{
    align-items: flex-end;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:justify-end{
    justify-content: flex-end;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }

  .xl\\:gap-\\[1rem\\]{
    gap: 1rem;
  }

  .xl\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .xl\\:overflow-hidden{
    overflow: hidden;
  }

  .xl\\:overflow-y-auto{
    overflow-y: auto;
  }

  .xl\\:rounded-3xl{
    border-radius: 2rem;
  }

  .xl\\:pb-0{
    padding-bottom: 0px;
  }

  .xl\\:pb-20{
    padding-bottom: 5rem;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .\\32xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_24rem\\]{
    grid-template-columns: minmax(0,1fr) 24rem;
  }

  .\\32xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_26rem\\]{
    grid-template-columns: minmax(0,1fr) 26rem;
  }

  .\\32xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_28rem\\]{
    grid-template-columns: minmax(0,1fr) 28rem;
  }
}
@media print{

  .print\\:m-0{
    margin: 0px;
  }

  .print\\:block{
    display: block;
  }

  .print\\:grid{
    display: grid;
  }

  .print\\:hidden{
    display: none;
  }

  .print\\:break-after-page{
    page-break-after: always;
    break-after: page;
  }

  .print\\:rounded-none{
    border-radius: 0px;
  }

  .print\\:border-slate-400{
    --tw-border-opacity: 1;
    border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
  }

  .print\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .print\\:p-0{
    padding: 0px;
  }

  .print\\:p-\\[10mm\\]{
    padding: 10mm;
  }

  .print\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media (min-width: 1024px){

  .\\[\\&\\>div\\:first-child\\]\\:lg\\:border-t-0>div:first-child{
    border-top-width: 0px;
  }

  .\\[\\&\\>div\\:first-child\\]\\:lg\\:pt-0>div:first-child{
    padding-top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,0KAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,yDAAc;IAAd,eAAc;IAAd,uBAAc;EAAA;;EAAd;IAAA,mCAAc;IAAd,kCAAc;EAAA;;EAAd;IAAA;MAAA,eAAc;IAAA;EAAA;;EAAd;IAAA;MAAA,eAAc;IAAA;EAAA;;EAAd;EAAA,WAAc;EAAd,kBAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,YAAc;EAAd,0KAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,mCAAc;EAAd,kCAAc;EAAd,+FAAc;EAAd,yDAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,sDAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;IAAA,mCAAc;IAAd,kCAAc;IAAd,uDAAc;IAAd,wBAAc;EAAA;;EAAd,0CAAc;EAAd;;;;IAAA,6BAAc;EAAA;;EAAd,2DAAc;EAAd;IAAA,WAAc;IAAd,oBAAc;IAAd,eAAc;IAAd,UAAc;IAAd,YAAc;IAAd;;;;wBAAc;EAAA;;EAAd,wEAAc;EAAd;EAAA;AAAc;;EAAd;EAAA,cAAc;EAAd,0BAAc;EAAd,+FAAc;EAAd,yDAAc;EAAd;AAAc;;EAAd;EAAA,WAAc;EAAd,qBAAc;EAAd;AAAc;;EAAd;IAAA,UAAc;IAAd,WAAc;EAAA;;EAAd;EAAA,uBAAc;EAAd,kBAAc;EAAd;AAAc;;EAAd;EAAA,yBAAc;AAAA;;EAAd,+OAAA,kBAAc,EAAA;;EAAd;EAAA,kBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;;EA+FlB,0CAA0C;EAC1C;IACE;MACE,UAAU;MACV,uCAAuC;IACzC;;IAEA;MACE,UAAU;MACV,iCAAiC;IACnC;EACF;;EAEA;IACE,uEAAuE;IACvE,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,kBAAwD;IAAxD,UAAwD;IAAxD,SAAwD;IAAxD,UAAwD;IAAxD,YAAwD;IAAxD,6BAAwD;EAC1D;;EAEA,qBAAqB;;EAOrB;IACE,kCAAuB;EACzB;;EAFA;IACE,uBAAuB;EACzB;;EAMA,oBAAoB;EACpB;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;;IAEA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,0CAA0C;IAC1C,+BAA+B;EACjC;;EAOA;IACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,OAAO,UAAU,EAAE,oCAAoC,MAAM;EAC/D;;EAEA,qDAAqD;EACrD;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,qCAAqC;EAEnC;EAAA,oMAAsP;EAAtP,qBAAsP;EAAtP,iBAAsP;EAAtP,yBAAsP;EAAtP,sCAAsP;EAAtP,qBAAsP;EAAtP,sBAAsP;EAAtP,qBAAsP;EAAtP,wBAAsP;EAAtP,gBAAsP;EAAtP,gCAAsP;EAAtP,0CAAsP;EAAtP,uDAAsP;EAAtP,uGAAsP;EAAtP,wBAAsP;EAAtP,yDAAsP;EAAtP,0BAAsP;EAAtP;AAAsP;EAAtP;EAAA,qBAAsP;AAAA;EAAtP;;EAAA,yBAAsP;EAAtP,yBAAsP;AAAA;EAAtP;EAAA,0CAAsP;AAAA;EAAtP;EAAA,2CAAsP;AAAA;EAAtP,uOAAA,kBAAsP,EAAA;EAAtP,4MAAA,wCAAsP,EAAA;EAAtP;EAAA;AAAsP;EAAtP;EAAA,kBAAsP;EAAtP,kBAAsP;EAAtP;AAAsP;EADxP;IAEE,wCAAwC;IACxC,wBAAwB;EAC1B;;EAGE;EAAA,oMAAwP;EAAxP,qBAAwP;EAAxP,iBAAwP;EAAxP,yBAAwP;EAAxP,kBAAwP;EAAxP,4DAAwP;EAAxP,qBAAwP;EAAxP,sBAAwP;EAAxP,qBAAwP;EAAxP,wBAAwP;EAAxP,gBAAwP;EAAxP,oBAAwP;EAAxP,gDAAwP;EAAxP,wBAAwP;EAAxP,yDAAwP;EAAxP,0BAAwP;EAAxP;AAAwP;;EAAxP;EAAA,qBAAwP;AAAA;;EAAxP;;EAAA,yBAAwP;EAAxP,yBAAwP;AAAA;;EAAxP,yOAAA,kBAAwP,EAAA;;EAAxP;EAAA,kBAAwP;EAAxP;AAAwP;;EAAxP;EAAA,kBAAwP;EAAxP,kBAAwP;EAAxP;AAAwP;;EAAxP;EAAA,kBAAwP;EAAxP,yDAAwP;EAAxP,oBAAwP;EAAxP;AAAwP;;EAAxP;EAAA,kBAAwP;EAAxP;AAAwP;;EAD1P;IAEE,wCAAwC;IACxC,wBAAwB;EAC1B;;EAEA,2BAA2B;EAEzB;EAAA,oMAAiS;EAAjS,sBAAiS;EAAjS,iBAAiS;EAAjS,sBAAiS;EAAjS,4DAAiS;EAAjS,kBAAiS;EAAjS,4DAAiS;EAAjS,oBAAiS;EAAjS,gDAAiS;EAAjS,wBAAiS;EAAjS,yDAAiS;EAAjS,0BAAiS;EAAjS;AAAiS;EAAjS;EAAA,yBAAiS;AAAA;EAAjS;;EAAA,qBAAiS;AAAA;EAAjS;EAAA,qBAAiS;AAAA;EAAjS;;EAAA,yBAAiS;EAAjS,yBAAiS;AAAA;EAAjS,kOAAA,kBAAiS,EAAA;EAAjS,mMAAA,qBAAiS,EAAA;EAAjS;EAAA,kCAAiS;EAAjS,8BAAiS;EAAjS,mBAAiS;EAAjS,2GAAiS;EAAjS,yGAAiS;EAAjS,4FAAiS;EAAjS;AAAiS;EAAjS;EAAA,sBAAiS;EAAjS,yDAAiS;EAAjS,kBAAiS;EAAjS,yDAAiS;EAAjS,oBAAiS;EAAjS;AAAiS;EAAjS;EAAA;AAAiS;;EAGnS,iCAAiC;;EAKjC,mCAAmC;EAEjC;;EAAA;IAAA;EAA0H;AAAA;EAA1H;EAAA,kCAA0H;EAA1H,qBAA0H;EAA1H,iBAA0H;EAA1H,4DAA0H;EAA1H,sBAA0H;EAA1H;AAA0H;EAA1H;;EAAA,qBAA0H;AAAA;EAA1H,+JAAA,kBAA0H,EAAA;EAA1H,qMAAA,qBAA0H,EAAA;EAA1H;EAAA,yDAA0H;EAA1H,sBAA0H;EAA1H;AAA0H;EAE5H,yCAAyC;EAEvC;EAAA,mBAAqI;EAArI,iBAAqI;EAArI,sBAAqI;EAArI,4DAAqI;EAArI,kBAAqI;EAArI,4DAAqI;EAArI,eAAqI;EAArI,wCAAqI;EAArI,sDAAqI;EAArI;AAAqI;EAArI;EAAA,yBAAqI;EAArI,qBAAqI;AAAA;EAArI,yMAAA,qBAAqI,EAAA;EAArI;EAAA,qCAAqI;EAArI,kBAAqI;EAArI;AAAqI;;EAGvI,+BAA+B;EAE7B;EAAA,aAA8O;EAA9O,oMAA8O;EAA9O,mBAA8O;EAA9O,uBAA8O;EAA9O,qBAA8O;EAA9O,kBAA8O;EAA9O,2DAA8O;EAA9O,gBAA8O;EAA9O,oBAA8O;EAA9O,mDAA8O;EAA9O,wBAA8O;EAA9O,yDAA8O;EAA9O,0BAA8O;EAA9O;AAA8O;EAA9O;;EAAA,yBAA8O;EAA9O,yBAA8O;AAAA;EAA9O,uOAAA,kBAA8O,EAAA;EAA9O;EAAA,kBAA8O;EAA9O,kBAA8O;EAA9O,+LAA8O;EAA9O,kBAA8O;EAA9O,0DAA8O;EAA9O,+EAA8O;EAA9O,mGAA8O;EAA9O,uGAA8O;EAA9O,wCAA8O;EAA9O;AAA8O;EAA9O;EAAA,iBAA8O;EAA9O,iBAA8O;EAA9O;AAA8O;EAG9O;EAAA,aAAkO;EAAlO,oMAAkO;EAAlO,mBAAkO;EAAlO,uBAAkO;EAAlO,qBAAkO;EAAlO,kBAAkO;EAAlO,0DAAkO;EAAlO,gBAAkO;EAAlO,oBAAkO;EAAlO,mDAAkO;EAAlO,wBAAkO;EAAlO,yDAAkO;EAAlO,0BAAkO;EAAlO;AAAkO;EAAlO;;EAAA,yBAAkO;EAAlO,yBAAkO;AAAA;EAAlO,sOAAA,kBAAkO,EAAA;EAAlO;EAAA,kBAAkO;EAAlO,kBAAkO;EAAlO,+LAAkO;EAAlO,kBAAkO;EAAlO,0DAAkO;EAAlO,+EAAkO;EAAlO,mGAAkO;EAAlO,uGAAkO;EAAlO,uCAAkO;EAAlO;AAAkO;EAAlO;EAAA,iBAAkO;EAAlO,iBAAkO;EAAlO;AAAkO;EAGlO;EAAA,aAA4P;EAA5P,oMAA4P;EAA5P,mBAA4P;EAA5P,uBAA4P;EAA5P,qBAA4P;EAA5P,kBAA4P;EAA5P,4DAA4P;EAA5P,gBAA4P;EAA5P,oBAA4P;EAA5P,gDAA4P;EAA5P,wBAA4P;EAA5P,yDAA4P;EAA5P,0BAA4P;EAA5P;AAA4P;EAA5P;;EAAA,yBAA4P;EAA5P,yBAA4P;EAA5P,yBAA4P;AAAA;EAA5P,yOAAA,kBAA4P,EAAA;EAA5P;EAAA,kBAA4P;EAA5P,kBAA4P;EAA5P,+LAA4P;EAA5P,kBAA4P;EAA5P;AAA4P;EAA5P;EAAA,iBAA4P;EAA5P,iBAA4P;EAA5P;AAA4P;EAA5P;EAAA,kBAA4P;EAA5P,yDAA4P;EAA5P,oBAA4P;EAA5P;AAA4P;EAA5P;EAAA,kBAA4P;EAA5P;AAA4P;AApNhQ;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,UAAmB;IAAnB;EAAmB;;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AA4MA,mCAAmC;AACnC;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;AACA;EACE,kFAAkF;AACpF;AACA;EACE,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,wDAAwD;EACxD,gCAAgC;EAChC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,sCAAsC;AACtC;EACE,8CAA8C;EAC9C,uBAAuB;AACzB;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,KAAK,uCAAuC,EAAE,UAAU,EAAE;EAC1D,MAAM,sCAAsC,EAAE,UAAU,EAAE;EAC1D,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;AACA;EACE,+EAA+E;AACjF;;AAEA,yCAAyC;AACzC;EACE;IACE,mCAAmC;IACnC,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;IAC/B,yDAAyD;EAC3D;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,yBAAyB;EAC3B;AACF;;AAEA;;;;;CAKC;AACD;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;;EAEE,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;CAMC;AACD;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;;EAEE,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD,kCAAkC;AAClC;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;;;;EAIE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;;CAIC;AACD;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,iDAAiD;EACjD,2CAA2C;AAC7C;;AAEA;;;EAGE,uDAAuD;AACzD;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;CAIC;AACD;;EAEE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;CAIC;AACD;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;CAIC;AACD;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;;EAEE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;;;;CAIC;AACD;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;;;CAIC;AACD;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;CAIC;AACD;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;CAIC;AACD;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;;;CAIC;AACD;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,2CAA2C;AAC3C;EACE,sDAAsD;AACxD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;;;CAIC;AACD;EACE,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;;;;CAIC;AACD;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;;;;CAKC;AACD;;EAEE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;;;;uEAeuE;;AAEvE;;;qEAGqE;AACrE;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;;qEAGqE;AACrE;EACE,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;wDAEwD;;AAExD,oBAAoB;AACpB;EACE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,4DAA4D;AAC9D;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,8BAA8B;EAC9B,0DAA0D;EAC1D,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,sCAAsC;EACtC,2DAA2D;AAC7D;AACA;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,yDAAyD;AAC3D;AACA;EACE,0DAA0D;AAC5D;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,iDAAiD;AACnD;AACA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uDAAuD;AACzD;AACA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;;;0DAG0D;AAC1D;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,6DAA6D;EAC7D,4DAA4D;AAC9D;AACA;EACE,4CAA4C;EAC5C,yDAAyD;AAC3D;;AAEA,WAAW;AACX;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,4DAA4D;AAC9D;AACA;EACE,oCAAoC;EACpC,2DAA2D;AAC7D;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;6EAE6E;;AAE7E;;oEAEoE;AACpE;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,yEAAyE;AACzE;EACE,wCAAwC;EAExC,sBAAsB;AACxB;;AAEA;mFACmF;AACnF;;;EAGE,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;2CAC2C,kBAAkB,EAAE;;AAE/D;;kGAEkG;AAClG;EACE,2EAA2E,aAAa,EAAE;AAC5F;;;;;AAKA;;;;iDAIiD;AACjD,sBAAsB,oCAAoC,EAAE;AAC5D,kOAAkO,6BAA6B,EAAE;AACjQ,8JAA8J,6BAA6B,EAAE;AAC7L,qMAAqM,mDAAmD,EAAE;AAC1P,wJAAwJ,6BAA6B,EAAE,qBAAqB,EAAE;AAC9M,8JAA8J,gCAAgC,EAAE,sDAAsD,EAAE,wBAAwB,EAAE;AAClR,yMAAyM,gCAAgC,EAAE;AAC3O,mDAAmD;AACnD,sMAAsM,oCAAoC,EAAE;AAC5O,6NAA6N,oCAAoC,EAAE;AACnQ,iKAAiK,yBAAyB,EAAE;AAC5L,2JAA2J,oCAAoC,EAAE;AACjM,wLAAwL,gCAAgC,EAAE;;AAE1N;sFACsF;AACtF,yBAAyB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC9E,+BAA+B,eAAe,EAAE,cAAc,EAAE;AAChE,6CAA6C,mBAAmB,EAAE;AAClE,0CAA0C,iBAAiB,EAAE;AAC7D,yBAAyB,0BAA0B,EAAE;AAtqCrD;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,qBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,mBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,mBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,2BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,iBAuqCA;EAvqCA,iBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,6BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,6BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,yEAuqCA;EAvqCA,qEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,+EAuqCA;EAvqCA,qEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,4DAuqCA;EAvqCA,kEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,4DAuqCA;EAvqCA,mEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,0EAuqCA;EAvqCA,8FAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,gDAuqCA;EAvqCA,6DAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,uCAuqCA;EAvqCA,sDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,+EAuqCA;EAvqCA,mGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,6EAuqCA;EAvqCA,iGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0CAuqCA;EAvqCA,uDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,mCAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,gCAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,gCAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,+EAuqCA;EAvqCA,mGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,8BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,qBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,iBAuqCA;EAvqCA,iBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA,8BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2GAuqCA;EAvqCA,yGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,eAuqCA;EAvqCA,eAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,0BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,yBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,mBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,iBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,iBAuqCA;EAvqCA,iBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,0EAuqCA;EAvqCA,8FAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,6EAuqCA;EAvqCA,iGAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,0CAuqCA;EAvqCA,uDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,gFAuqCA;EAvqCA,oGAuqCA;EAvqCA;AAuqCA;AAvqCA;;EAAA;IAAA,yBAuqCA;IAvqCA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;AAAA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,uEAuqCA;EAvqCA,iEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,yDAuqCA;EAvqCA,+DAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,wEAuqCA;EAvqCA,kEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,uEAuqCA;EAvqCA,iEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,uEAuqCA;EAvqCA,iEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,4DAuqCA;EAvqCA,kEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,gEAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,2BAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,qCAuqCA;EAvqCA,oDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,qCAuqCA;EAvqCA,oDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,8CAuqCA;EAvqCA,6DAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,uCAuqCA;EAvqCA,sDAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA;AAuqCA;AAvqCA;EAAA,sBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,kBAuqCA;EAvqCA;AAuqCA;AAvqCA;EAAA,oBAuqCA;EAvqCA;AAuqCA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,sBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,6BAuqCA;IAvqCA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,gBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,wBAuqCA;IAvqCA,0DAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,wBAuqCA;IAvqCA,kEAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,eAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,eAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,uBAuqCA;IAvqCA,8DAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,gBAuqCA;IAvqCA,uBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,sBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,qBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,gBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,eAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,eAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,6EAuqCA;IAvqCA,iGAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,gBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,uBAuqCA;IAvqCA,2DAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,sBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,oBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,mBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,eAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,iBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,uBAuqCA;IAvqCA,2DAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,wBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,sBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA,kBAuqCA;IAvqCA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;;EAvqCA;IAAA,gBAuqCA;IAvqCA;EAuqCA;AAAA;AAvqCA;;EAAA;IAAA;EAuqCA;;EAvqCA;IAAA;EAuqCA;AAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Prompt:wght@300;400;500;600;700&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --color-primary: #000000;\n  --color-primary-hover: #333333;\n  --color-primary-text: #ffffff;\n}\n\nhtml.dark {\n  --color-primary: #ffffff;\n  --color-primary-hover: #e5e5ea;\n  --color-primary-text: #000000;\n}\n\n@layer base {\n  html {\n    /* ปรับฐานฟอนต์ให้พอดีกับจอ: มือถือเล็กหน่อย PC กำลังดี */\n    font-size: 14px;\n    scroll-behavior: smooth;\n  }\n  \n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  @media (min-width: 768px) {\n    html {\n      font-size: 15px;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    html {\n      font-size: 16px;\n    }\n  }\n\n  body {\n    @apply font-sans bg-[#f5f5f7] dark:bg-black text-[#1d1d1f] dark:text-[#f5f5f7] m-0 p-0 overflow-x-hidden antialiased transition-colors duration-500;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* letter-spacing เล็กน้อยเพื่อให้เหมือน Apple SF Pro */\n    letter-spacing: -0.015em;\n  }\n\n  /* Force no italic globally as requested */\n  i,\n  em,\n  .italic,\n  .font-italic {\n    font-style: normal !important;\n  }\n\n  /* Fixed Background Pattern: ลื่นหัวแตกเพราะใช้ Layer แยก */\n  body::before {\n    content: \"\";\n    @apply fixed inset-0 pointer-events-none -z-50;\n    background-image:\n      radial-gradient(at 0% 0%, rgba(37, 99, 235, 0.03) 0px, transparent 50%),\n      radial-gradient(at 100% 100%,\n        rgba(37, 99, 235, 0.03) 0px,\n        transparent 50%);\n  }\n\n  /* เจาะจงตัวห่อหน้าเท่านั้น ไม่ใช่ <main> ทุกตัว ดูเหตุผลที่กฎด้านล่าง */\n  #main-scroll-container > main {\n    @apply min-h-[80vh];\n  }\n\n  a {\n    @apply no-underline text-inherit transition-colors duration-200;\n  }\n\n  ul {\n    @apply list-none p-0 m-0;\n  }\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    @apply bg-slate-300 rounded-md;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    @apply bg-slate-400;\n  }\n}\n\n@layer components {\n\n  /*  แอนิเมชัน Dropdown: เด้งดึ๋ง ทันสมัย */\n  @keyframes slideDownPop {\n    from {\n      opacity: 0;\n      transform: translateY(-8px) scale(0.95);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0) scale(1);\n    }\n  }\n\n  .animate-slideDownPop {\n    animation: slideDownPop 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n    will-change: opacity, transform;\n    position: relative;\n  }\n\n  /* สะพานล่องหนเชื่อมปุ่มกับเมนู */\n  .animate-slideDownPop::before {\n    content: \"\";\n    @apply absolute -top-4 left-0 right-0 h-4 bg-transparent;\n  }\n\n  /* Mobile Accordion */\n  .accordion-grid {\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .accordion-grid.open {\n    grid-template-rows: 1fr;\n  }\n\n  .accordion-inner {\n    @apply overflow-hidden;\n  }\n\n  /* Page Transition */\n  @keyframes pageFade {\n    0% {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .animate-pageFade {\n    animation: pageFade 0.4s ease-out forwards;\n    will-change: opacity, transform;\n  }\n\n  .animate-modalIn {\n    animation: modalIn 0.25s ease-out forwards;\n    will-change: opacity, transform;\n  }\n\n  @keyframes modalIn {\n    from { opacity: 0; transform: scale(0.92) translateY(-8px); }\n    to   { opacity: 1; transform: scale(1)    translateY(0);     }\n  }\n\n  /* ️ Utility: Hide scrollbar but keep functionality */\n  .scrollbar-hide::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  /* Apple Style Buttons (Monochrome) */\n  .btn-apple-primary {\n    @apply bg-[var(--color-primary)] hover:bg-[var(--color-primary-hover)] text-[var(--color-primary-text)] font-medium px-5 py-2.5 rounded-2xl transition-all duration-300 ease-out shadow-sm active:scale-[0.98] border border-transparent transform-gpu;\n    will-change: transform, background-color;\n    transform: translateZ(0);\n  }\n  \n  .btn-apple-secondary {\n    @apply bg-[#e8e8ed] hover:bg-[#d1d1d6] dark:bg-[#2c2c2e] dark:hover:bg-[#3a3a3c] text-[#1d1d1f] dark:text-[#f5f5f7] font-medium px-5 py-2.5 rounded-2xl transition-all duration-300 ease-out active:scale-[0.98] border border-transparent transform-gpu;\n    will-change: transform, background-color;\n    transform: translateZ(0);\n  }\n\n  /* Apple Input Focus Ring */\n  .apple-input {\n    @apply border border-slate-200 dark:border-[#38383a] bg-white dark:bg-[#1c1c1e] text-[#1d1d1f] dark:text-[#f5f5f7] rounded-xl focus:outline-none focus:border-[var(--color-primary)] focus:ring-4 focus:ring-black/20 dark:focus:ring-white/20 transition-all duration-300 ease-out transform-gpu;\n  }\n\n  /* Smooth Hover Scale for Cards */\n  .hover-scale {\n    @apply transition-transform duration-300 ease-out hover:scale-[1.02] transform-gpu;\n  }\n\n  /* Apple Style Minimalist Spinner */\n  .apple-spinner {\n    @apply rounded-full border-[3px] border-slate-200 dark:border-zinc-700 border-t-slate-900 dark:border-t-white animate-spin;\n  }\n  /* Apple Form Group (iOS Inset Grouped) */\n  .apple-form-group {\n    @apply bg-white dark:bg-[#1c1c1e] rounded-[2rem] p-6 shadow-[0_2px_10px_rgba(0,0,0,0.02)] border border-slate-100 dark:border-white/5;\n  }\n\n  /* Extreme Smoothness Buttons */\n  .btn-apple-success {\n    @apply bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl font-bold transition-all duration-300 ease-out transform-gpu hover:scale-[1.02] hover:shadow-lg hover:shadow-emerald-500/20 active:scale-95 flex items-center justify-center;\n  }\n  .btn-apple-danger {\n    @apply bg-red-500 hover:bg-red-600 text-white rounded-2xl font-bold transition-all duration-300 ease-out transform-gpu hover:scale-[1.02] hover:shadow-lg hover:shadow-red-500/20 active:scale-95 flex items-center justify-center;\n  }\n  .btn-apple-secondary {\n    @apply bg-slate-100 dark:bg-[#2c2c2e] hover:bg-slate-200 dark:hover:bg-[#3a3a3c] text-slate-800 dark:text-white rounded-2xl font-bold transition-all duration-300 ease-out transform-gpu hover:scale-[1.02] active:scale-95 flex items-center justify-center;\n  }\n}\n\n/* NProgress Apple Style Override */\n#nprogress .bar {\n  background: var(--color-primary) !important;\n  height: 3px !important;\n}\n#nprogress .peg {\n  box-shadow: 0 0 10px var(--color-primary), 0 0 5px var(--color-primary) !important;\n}\n#nprogress .spinner-icon {\n  border-top-color: var(--color-primary) !important;\n  border-left-color: var(--color-primary) !important;\n}\n\n/* Dynamic Island Style Toasts */\n.Toastify__toast-container {\n  z-index: 99999 !important;\n  top: 1rem !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  width: auto !important;\n  max-width: 90vw !important;\n}\n\n.Toastify__toast {\n  border-radius: 9999px !important;\n  padding: 8px 16px !important;\n  min-height: 48px !important;\n  font-family: inherit !important;\n  font-weight: 600 !important;\n  font-size: 0.875rem !important;\n  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.2) !important;\n  margin-bottom: 0.5rem !important;\n  backdrop-filter: blur(16px) !important;\n  -webkit-backdrop-filter: blur(16px) !important;\n}\n\n/* Toastify Monochrome/Apple mapping */\n.Toastify__toast-theme--colored.Toastify__toast--success {\n  background: rgba(16, 185, 129, 0.9) !important;\n  color: white !important;\n}\n.Toastify__toast-theme--colored.Toastify__toast--error {\n  background: rgba(239, 68, 68, 0.9) !important;\n  color: white !important;\n}\n.Toastify__toast-theme--colored.Toastify__toast--info {\n  background: rgba(0, 0, 0, 0.85) !important;\n  color: white !important;\n}\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n  background: rgba(245, 158, 11, 0.9) !important;\n  color: white !important;\n}\n\n/* Spring Animations for Toasts */\n@keyframes island-bounce {\n  0% { transform: translateY(-150%) scale(0.9); opacity: 0; }\n  60% { transform: translateY(10%) scale(1.02); opacity: 1; }\n  100% { transform: translateY(0) scale(1); opacity: 1; }\n}\n.Toastify__bounce-enter--top-center {\n  animation: island-bounce 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards !important;\n}\n\n/*  Optimized Toast for Mobile (Global) */\n@media (max-width: 640px) {\n  .Toastify__toast-container {\n    width: calc(100% - 24px) !important;\n    left: 12px !important;\n    top: 12px !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .Toastify__toast {\n    min-height: 44px !important;\n    border-radius: 12px !important;\n    margin-bottom: 10px !important;\n    padding: 10px 14px !important;\n    font-family: inherit !important;\n    box-shadow: 0 8px 20px -5px rgba(0, 0, 0, 0.1) !important;\n  }\n\n  .Toastify__toast-body {\n    font-size: 13px !important;\n    font-weight: 500 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    line-height: 1.4 !important;\n  }\n\n  .Toastify__toast-icon {\n    width: 16px !important;\n    margin-right: 10px !important;\n    flex-shrink: 0 !important;\n  }\n}\n\n/*\n===================================================\nELEGANT DARK THEME\nModern dark theme with subtle depth and contrast.\n===================================================\n*/\nhtml.dark body,\nhtml.dark main,\nhtml.dark section {\n  background-color: #0f0f14 !important;\n  color: #e2e8f0 !important;\n}\n\n/* Dark backgrounds with subtle depth */\nhtml.dark .bg-white {\n  background-color: #1a1a24 !important;\n}\n\nhtml.dark .bg-slate-50,\nhtml.dark .bg-slate-100 {\n  background-color: #1e1e28 !important;\n}\n\nhtml.dark .bg-slate-200 {\n  background-color: #2a2a38 !important;\n}\n\nhtml.dark .bg-slate-800,\nhtml.dark .bg-slate-900 {\n  background-color: #000000 !important;\n}\n\nhtml.dark .bg-slate-950 {\n  background-color: #000000 !important;\n}\n\nhtml.dark .bg-gray-50,\nhtml.dark .bg-gray-100 {\n  background-color: #1a1a24 !important;\n}\n\nhtml.dark .bg-gray-200 {\n  background-color: #2a2a38 !important;\n}\n\n/* Cards and elevated surfaces */\nhtml.dark .bg-slate-300,\nhtml.dark .bg-gray-300 {\n  background-color: #32324a !important;\n}\n\n/* Text colors - maintain readability */\nhtml.dark h1,\nhtml.dark h2,\nhtml.dark h3,\nhtml.dark h4,\nhtml.dark h5,\nhtml.dark h6 {\n  color: #f1f5f9 !important;\n}\n\nhtml.dark p,\nhtml.dark span,\nhtml.dark div,\nhtml.dark li,\nhtml.dark ul {\n  color: #cbd5e1 !important;\n}\n\nhtml.dark a {\n  color: #94a3b8 !important;\n}\n\nhtml.dark a:hover {\n  color: #e2e8f0 !important;\n}\n\n/*\n===================================================\nVIBRANT EXCEPTIONS\nAllows critical UI elements (Stars, Status) to\nretain their colors amidst the dark theme.\n===================================================\n*/\nhtml.dark .text-yellow-400,\nhtml.dark .text-yellow-500 {\n  color: #facc15 !important;\n}\n\nhtml.dark .text-amber-400,\nhtml.dark .text-amber-500 {\n  color: #fbbf24 !important;\n}\n\nhtml.dark .text-rose-400,\nhtml.dark .text-rose-500,\nhtml.dark .text-rose-600 {\n  color: #fb7185 !important;\n}\n\nhtml.dark .text-red-400,\nhtml.dark .text-red-500 {\n  color: #f87171 !important;\n}\n\nhtml.dark .text-emerald-400,\nhtml.dark .text-emerald-500,\nhtml.dark .text-emerald-600 {\n  color: #34d399 !important;\n}\n\nhtml.dark .text-green-400,\nhtml.dark .text-green-500 {\n  color: #4ade80 !important;\n}\n\nhtml.dark .text-blue-400,\nhtml.dark .text-blue-500 {\n  color: #60a5fa !important;\n}\n\nhtml.dark .text-cyan-400,\nhtml.dark .text-cyan-500 {\n  color: #22d3ee !important;\n}\n\nhtml.dark .text-indigo-400,\nhtml.dark .text-indigo-500 {\n  color: #818cf8 !important;\n}\n\nhtml.dark .text-violet-400,\nhtml.dark .text-violet-500 {\n  color: #a78bfa !important;\n}\n\nhtml.dark .text-purple-400,\nhtml.dark .text-purple-500 {\n  color: #c084fc !important;\n}\n\nhtml.dark .text-pink-400,\nhtml.dark .text-pink-500 {\n  color: #f472b6 !important;\n}\n\nhtml.dark .text-orange-400,\nhtml.dark .text-orange-500 {\n  color: #fb923c !important;\n}\n\n/* Star Rating Specifics */\nhtml.dark .star-filled {\n  color: #facc15 !important;\n}\n\nhtml.dark .star-empty {\n  color: #3f3f46 !important;\n}\n\n/* Primary/Secondary colors for buttons */\nhtml.dark .text-primary {\n  color: #60a5fa !important;\n}\n\nhtml.dark .text-secondary {\n  color: #94a3b8 !important;\n}\n\n/* Ensure placeholders are visible but subdued in dark mode */\nhtml.dark input::placeholder,\nhtml.dark textarea::placeholder {\n  color: #64748b !important;\n}\n\n/*\n===================================================\nBORDERS & INPUTS\n===================================================\n*/\n/* Subtle borders for dark theme */\nhtml.dark .border-slate-100,\nhtml.dark .border-slate-200,\nhtml.dark .border-gray-100,\nhtml.dark .border-gray-200 {\n  border-color: #2e2e3a !important;\n}\n\nhtml.dark .border-slate-300,\nhtml.dark .border-gray-300 {\n  border-color: #3f3f52 !important;\n}\n\nhtml.dark .border {\n  border-color: #2e2e3a !important;\n}\n\n/* Input fields */\nhtml.dark input,\nhtml.dark textarea,\nhtml.dark select {\n  background-color: #1a1a24 !important;\n  border-color: #2e2e3a !important;\n  color: #e2e8f0 !important;\n}\n\nhtml.dark input:focus,\nhtml.dark textarea:focus,\nhtml.dark select:focus {\n  background-color: #1e1e28 !important;\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;\n}\n\nhtml.dark input:disabled,\nhtml.dark textarea:disabled,\nhtml.dark select:disabled {\n  background-color: #12121a !important;\n  color: #64748b !important;\n}\n\n/*\n===================================================\nCARDS & CONTAINERS\n===================================================\n*/\nhtml.dark .card,\nhtml.dark .rounded-lg,\nhtml.dark .rounded-xl,\nhtml.dark .rounded-2xl {\n  background-color: #1a1a24 !important;\n  border: 1px solid #2e2e3a !important;\n}\n\nhtml.dark .bg-card,\nhtml.dark .bg-white\\/50,\nhtml.dark .bg-white\\/10 {\n  background-color: #1a1a24 !important;\n}\n\n/*\n===================================================\nBUTTONS\n===================================================\n*/\nhtml.dark button,\nhtml.dark .btn {\n  transition: all 0.2s ease;\n}\n\nhtml.dark .btn-primary,\nhtml.dark .bg-blue-600,\nhtml.dark .bg-blue-500 {\n  background-color: var(--color-primary) !important;\n  color: var(--color-primary-text) !important;\n}\n\nhtml.dark .btn-primary:hover,\nhtml.dark .bg-blue-600:hover,\nhtml.dark .bg-blue-500:hover {\n  background-color: var(--color-primary-hover) !important;\n}\n\nhtml.dark .btn-secondary,\nhtml.dark .bg-gray-500,\nhtml.dark .bg-slate-500 {\n  background-color: #3f3f52 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml.dark .btn-secondary:hover,\nhtml.dark .bg-gray-500:hover,\nhtml.dark .bg-slate-500:hover {\n  background-color: #52525b !important;\n}\n\nhtml.dark .btn-outline-primary {\n  border-color: #3b82f6 !important;\n  color: #60a5fa !important;\n}\n\nhtml.dark .btn-outline-primary:hover {\n  background-color: #1e40af !important;\n  color: #ffffff !important;\n}\n\nhtml.dark .btn-outline-secondary {\n  border-color: #475569 !important;\n  color: #94a3b8 !important;\n}\n\nhtml.dark .btn-outline-secondary:hover {\n  background-color: #334155 !important;\n  color: #e2e8f0 !important;\n}\n\n/*\n===================================================\nTABLES\n===================================================\n*/\nhtml.dark table {\n  color: #e2e8f0 !important;\n}\n\nhtml.dark th,\nhtml.dark td {\n  border-color: #2e2e3a !important;\n}\n\nhtml.dark thead {\n  background-color: #1e1e28 !important;\n}\n\nhtml.dark tbody tr:hover {\n  background-color: #1a1a24 !important;\n}\n\n/*\n===================================================\nMODALS & OVERLAYS\n===================================================\n*/\nhtml.dark .modal-content,\nhtml.dark .dialog-content {\n  background-color: #1a1a24 !important;\n  border: 1px solid #2e2e3a !important;\n}\n\nhtml.dark .modal-header,\nhtml.dark .modal-footer {\n  border-color: #2e2e3a !important;\n}\n\n/*\n===================================================\nSCROLLBARS\n===================================================\n*/\nhtml.dark ::-webkit-scrollbar-thumb {\n  background-color: #3f3f52 !important;\n}\n\nhtml.dark ::-webkit-scrollbar-thumb:hover {\n  background-color: #52526b !important;\n}\n\n/*\n===================================================\nBADGES & TAGS\n===================================================\n*/\nhtml.dark .bg-blue-100,\nhtml.dark .bg-blue-200 {\n  background-color: #1e3a5f !important;\n  color: #93c5fd !important;\n}\n\nhtml.dark .bg-green-100,\nhtml.dark .bg-green-200 {\n  background-color: #14532d !important;\n  color: #86efac !important;\n}\n\nhtml.dark .bg-yellow-100,\nhtml.dark .bg-yellow-200 {\n  background-color: #422006 !important;\n  color: #fde047 !important;\n}\n\nhtml.dark .bg-red-100,\nhtml.dark .bg-red-200 {\n  background-color: #450a0a !important;\n  color: #fca5a5 !important;\n}\n\nhtml.dark .bg-gray-100,\nhtml.dark .bg-gray-200 {\n  background-color: #27272a !important;\n  color: #a1a1aa !important;\n}\n\n/*\n===================================================\nNAVBAR & HEADER\n===================================================\n*/\nhtml.dark nav,\nhtml.dark header {\n  background-color: #0f0f14 !important;\n  border-bottom: 1px solid #2e2e3a !important;\n}\n\n/*\n===================================================\nFOOTER\n===================================================\n*/\nhtml.dark footer {\n  background-color: #0a0a0f !important;\n  border-top: 1px solid #2e2e3a !important;\n}\n\n/*\n===================================================\nALERTS & NOTIFICATIONS\n===================================================\n*/\nhtml.dark .alert {\n  border-color: #2e2e3a !important;\n}\n\nhtml.dark .alert-success {\n  background-color: #05261f !important;\n  border-color: #065f46 !important;\n  color: #6ee7b7 !important;\n}\n\nhtml.dark .alert-danger {\n  background-color: #450a0a !important;\n  border-color: #991b1b !important;\n  color: #fca5a5 !important;\n}\n\nhtml.dark .alert-warning {\n  background-color: #422006 !important;\n  border-color: #92400e !important;\n  color: #fde047 !important;\n}\n\nhtml.dark .alert-info {\n  background-color: #0c4a6e !important;\n  border-color: #0369a1 !important;\n  color: #7dd3fc !important;\n}\n\n/*\n===================================================\nDROPDOWN & SELECT\n===================================================\n*/\nhtml.dark .dropdown-menu {\n  background-color: #1a1a24 !important;\n  border: 1px solid #2e2e3a !important;\n}\n\nhtml.dark .dropdown-item {\n  color: #cbd5e1 !important;\n}\n\nhtml.dark .dropdown-item:hover {\n  background-color: #2a2a38 !important;\n  color: #f1f5f9 !important;\n}\n\n/*\n===================================================\nFORM GROUPS\n===================================================\n*/\nhtml.dark .form-label {\n  color: #94a3b8 !important;\n}\n\nhtml.dark .form-text {\n  color: #64748b !important;\n}\n\nhtml.dark .form-check-input {\n  background-color: #1a1a24 !important;\n  border-color: #475569 !important;\n}\n\nhtml.dark .form-check-input:checked {\n  background-color: #3b82f6 !important;\n  border-color: #3b82f6 !important;\n}\n\n/*\n===================================================\nTABS\n===================================================\n*/\nhtml.dark .nav-tabs {\n  border-color: #2e2e3a !important;\n}\n\nhtml.dark .nav-tabs .nav-link {\n  color: #94a3b8 !important;\n}\n\nhtml.dark .nav-tabs .nav-link:hover {\n  color: #e2e8f0 !important;\n  border-color: #3f3f52 !important;\n}\n\nhtml.dark .nav-tabs .nav-link.active {\n  background-color: #1a1a24 !important;\n  border-color: #2e2e3a #2e2e3a #1a1a24 !important;\n  color: #f1f5f9 !important;\n}\n\n/*\n===================================================\nPAGINATION\n===================================================\n*/\nhtml.dark .page-link {\n  background-color: #1a1a24 !important;\n  border-color: #2e2e3a !important;\n  color: #94a3b8 !important;\n}\n\nhtml.dark .page-link:hover {\n  background-color: #2a2a38 !important;\n  color: #e2e8f0 !important;\n}\n\nhtml.dark .page-item.active .page-link {\n  background-color: #3b82f6 !important;\n  border-color: #3b82f6 !important;\n  color: #ffffff !important;\n}\n\n/*\n===================================================\nSPINNER & LOADER\n===================================================\n*/\nhtml.dark .spinner-border {\n  border-color: #3f3f52 !important;\n  border-top-color: #60a5fa !important;\n}\n\n/*\n===================================================\nSHADOWS - APPLE STYLE (Softer, wider spread)\n===================================================\n*/\nhtml.dark .shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5) !important;\n}\n\nhtml.dark .shadow {\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.5) !important;\n}\n\nhtml.dark .shadow-lg {\n  box-shadow: 0 10px 30px -3px rgba(0, 0, 0, 0.6) !important;\n}\n\n/* Light mode overrides for Apple shadows */\n.shadow-sm {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05) !important;\n}\n\n.shadow {\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 12px 32px 0 rgba(0, 0, 0, 0.08) !important;\n}\n\n/*\n===================================================\nBACKDROP & OVERLAY\n===================================================\n*/\nhtml.dark .backdrop-blur-sm {\n  backdrop-filter: blur(4px);\n  background-color: rgba(15, 15, 20, 0.8) !important;\n}\n\n/*\n===================================================\nCODE & PRE\n===================================================\n*/\nhtml.dark code {\n  background-color: #1e1e28 !important;\n  color: #f472b6 !important;\n}\n\nhtml.dark pre {\n  background-color: #12121a !important;\n  border: 1px solid #2e2e3a !important;\n  color: #e2e8f0 !important;\n}\n\n/*\n===================================================\nPAGETOOL CHROME PROTECTION\nป้องกัน legacy CSS (portal.css) เขียนทับ Header และ body\n===================================================\n*/\nhtml,\nbody {\n  height: auto !important;\n  overflow: visible !important;\n}\n\nbody {\n  background-image: none !important;\n  background-color: #f8fafc !important;\n}\n\n/* ══════════════════════════════════════════════════════════════════\n   ลำดับชั้นการซ้อน (z-index) ของทั้งระบบ\n\n   ต่ำ    เนื้อหาในหน้า                        auto - 30\n          หัวข้อของแต่ละหน้าจอที่ sticky        30\n   กลาง   หัวเว็บหลัก (components/Header)      999\n   สูง    Modal · overlay เต็มจอ               10000\n          Toast ในหน้า                        10010\n          Lightbox ดูรูปเต็มจอ                 10020\n   สูงสุด  Toastify (react-toastify)           99999\n\n   ⚠ Modal ต้องอยู่เหนือหัวเว็บเสมอ ไม่ใช่ต่ำกว่า\n     กฎเดิมบังคับ header ทุกตัวเป็น 9999 !important ซึ่งสูงกว่า z-50\n     ที่ modal ใช้กันทั้งระบบ ผลคือหัวเว็บกับหัวหน้าจอทับหัว modal\n     ปุ่มปิด (X) โดนบังจนกดไม่ได้ (เจอที่ /admin/payroll)\n   ══════════════════════════════════════════════════════════════════ */\n\n/* หัวเว็บหลัก — ต้อง sticky เสมอ ไม่ให้ถูกเนื้อหาบัง\n   ⚠ เจาะจงที่ #app-header เท่านั้น\n     เดิมเป็น header[class*=\"sticky\"] ซึ่งจับ <header> ของทุกหน้าจอด้วย\n     หัวข้อของหน้าจอเลยถูกดันขึ้นไป 9999 ตามไปด้วยโดยไม่มีใครตั้งใจ */\n#app-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 999 !important;\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n/* main เว้นพื้นที่ header\n   จำกัดไว้เฉพาะ <main> ที่เป็นตัวห่อหน้า (ลูกโดยตรงของ #main-scroll-container)\n   เดิมบังคับ <main> ทุกตัว ซึ่งไปโดน <main> ที่หน้าต่าง ๆ ใช้เป็นกล่องเนื้อหา\n   ข้างในด้วย พอกล่องนั้นต้องสูงตามที่กำหนด มันจะล้นกรอบที่ครอบอยู่ */\n#main-scroll-container > main {\n  min-height: calc(100dvh - 300px);\n}\n\n/* ป้องกัน legacy portal.css ที่ใช้ aside, .nav-item เป็น global */\naside {\n  position: static !important;\n  z-index: auto !important;\n}\n\n/* ===================================================\n   GLOBAL UI OVERHAUL (SMOOTH & MINIMALIST)\n   =================================================== */\n\n/* Base Smoothness */\nbody {\n  color: #334155 !important;\n  background-color: #f8fafc !important;\n}\nhtml.dark body {\n  color: #e2e8f0 !important;\n  background-color: #0f172a !important;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  letter-spacing: -0.02em;\n}\nhtml.dark h1, html.dark h2, html.dark h3, html.dark h4, html.dark h5, html.dark h6 {\n  color: #f8fafc !important;\n}\n\n/* Transitions for everything interactive */\na, button, .btn, .card, .form-control, .form-select, .nav-link, .dropdown-item {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n/* Modern Cards */\n.card {\n  border: 1px solid rgba(226, 232, 240, 0.8) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.03) !important;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.95) !important;\n}\n.card:hover {\n  transform: translateY(-3px) !important;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08) !important;\n}\nhtml.dark .card {\n  border: 1px solid rgba(51, 65, 85, 0.5) !important;\n  background: rgba(30, 41, 59, 0.95) !important;\n  box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.2) !important;\n}\nhtml.dark .card:hover {\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3) !important;\n}\n\n/* Modern Buttons */\n.btn {\n  border-radius: 10px !important;\n  font-weight: 500 !important;\n}\n.btn:hover {\n  transform: scale(1.02) !important;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;\n}\n.btn:active {\n  transform: scale(0.98) !important;\n}\n\n/* Inputs & Form Controls */\n.form-control, .form-select {\n  border-radius: 10px !important;\n  border: 1px solid #cbd5e1 !important;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,0.02) !important;\n}\n.form-control:focus, .form-select:focus {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;\n}\nhtml.dark .form-control, html.dark .form-select {\n  background-color: #0f172a !important;\n  border-color: #334155 !important;\n  color: #f1f5f9 !important;\n}\n\n/* Glassmorphism Header */\n/* เจาะจงเฉพาะแถบบนของแอป ไม่ใช่ <header> ทุกตัวในระบบ\n   เดิมเลือกด้วยชื่อแท็กล้วน ๆ จึงไปโดนแถบหัวเรื่องที่หน้าอื่นใช้ <header>\n   ด้วย ทำให้กลายเป็นแถบขาวโปร่งกลางหน้าโดยไม่ได้ตั้งใจ\n   แถบบนของแอปเป็น sticky เสมอ ใช้ตรงนั้นแยกออกจากกันได้ */\nheader.sticky, header[class*=\"sticky\"], .navbar {\n  background: rgba(255, 255, 255, 0.8) !important;\n  backdrop-filter: blur(12px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(12px) saturate(180%) !important;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8) !important;\n}\nhtml.dark header.sticky, html.dark header[class*=\"sticky\"], html.dark .navbar {\n  background: rgba(15, 23, 42, 0.8) !important;\n  border-bottom: 1px solid rgba(51, 65, 85, 0.8) !important;\n}\n\n/* Tables */\n.table {\n  --bs-table-bg: transparent !important;\n}\n.table > :not(caption) > * > * {\n  border-bottom-color: #f1f5f9 !important;\n  padding: 1rem 0.75rem !important;\n}\nhtml.dark .table > :not(caption) > * > * {\n  border-bottom-color: #1e293b !important;\n}\n.table thead th {\n  font-weight: 600 !important;\n  letter-spacing: 0.05em;\n  color: #64748b !important;\n  background-color: #f8fafc !important;\n  border-bottom: 2px solid #e2e8f0 !important;\n}\nhtml.dark .table thead th {\n  color: #94a3b8 !important;\n  background-color: #0f172a !important;\n  border-bottom: 2px solid #334155 !important;\n}\n.table tbody tr {\n  transition: all 0.2s ease !important;\n}\n.table tbody tr:hover {\n  background-color: #f1f5f9 !important;\n}\nhtml.dark .table tbody tr:hover {\n  background-color: #1e293b !important;\n}\n\n/* Modal */\n.modal-content {\n  border-radius: 20px !important;\n  border: none !important;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;\n}\nhtml.dark .modal-content {\n  background-color: #1e293b !important;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;\n}\n\n/* Badges */\n.badge {\n  border-radius: 6px !important;\n  padding: 0.4em 0.6em !important;\n  font-weight: 500 !important;\n  letter-spacing: 0.02em;\n}\n\n/* ════════════════════════════════════════════════════════════════════════\n * มือถือ / iPad — ขั้นพื้นฐานที่ได้ทุกหน้า (28 ก.ย. 69)\n * ════════════════════════════════════════════════════════════════════════ */\n\n/* iPhone (Safari) ซูมหน้าจอเองเมื่อแตะช่องกรอกที่ตัวอักษรเล็กกว่า 16px และไม่ซูมกลับ\n   ผู้ใช้ต้องถ่างนิ้วออกเองทุกครั้งที่กรอก — บังคับ 16px เฉพาะจอเล็กกว่า md\n   (ใช้ !important เพราะคลาส text-xs/text-sm ของ Tailwind ต้องแพ้) */\n@media (max-width: 767px) {\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"file\"]):not([type=\"color\"]),\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n}\n\n/* แตะแล้วไม่มีกรอบสีเทาค้างของ iOS · หมุนจอแล้ว iOS ไม่ขยายตัวอักษรเอง */\nhtml {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n/* ใบประเมินราคา โหมดดู (/tools/price-estimate/:id) — ช่องที่ปิดอยู่ดูเป็นข้อความธรรมดาแบบเอกสาร (28 ก.ย. 69)\n   ใช้ตัวเดียวกับโหมดแก้ ไม่แยกเทมเพลต กันสองหน้าหน้าตาไม่ตรงกันเวลาเพิ่มช่องใหม่ */\n.est-view input:disabled:not([type=\"checkbox\"]):not([type=\"radio\"]),\n.est-view select:disabled,\n.est-view textarea:disabled {\n  border-color: transparent !important;\n  background: transparent !important;\n  color: #0f172a !important;\n  -webkit-text-fill-color: #0f172a;\n  opacity: 1 !important;\n  cursor: default;\n  appearance: none;\n  -webkit-appearance: none;\n}\n.est-view input:disabled::placeholder,\n.est-view textarea:disabled::placeholder { color: transparent; }\n\n/* หน้ากรอบนิ่ง (หัวอยู่กับที่ เลื่อนเฉพาะรายการ · lg:h-[calc(100dvh-61px)]) — ซ่อนแถบลิขสิทธิ์ท้ายจอบนจอคอม (2 ต.ค. 69)\n   แถบนี้อยู่ใต้หน้าในกล่องเลื่อนเดียวกัน หน้าที่สูงเต็มจอแล้วจึงเลื่อนทั้งหน้าได้อีก ~69px: หัวหน้าเลื่อนหาย\n   และแถบ \"เลื่อนลงดูต่อ\" ของคลัง BOM ถูกตัดใต้จอ (ผู้ใช้: \"ET467 มี 2 บอร์ด แต่เห็น BOM เดียว\") */\n@media (min-width: 1024px) {\n  #main-scroll-container:has([class*=\"lg:h-[calc(100dvh-61px)]\"]) > footer { display: none; }\n}\n\n\n\n\n/* ── ธีม Excel ของหน้าใบเสนอราคา / ใบแจ้งหนี้ / ใบกำกับภาษี (20 ต.ค. 69) ─────────────────────\n   ผู้ใช้: \"UI ยังเป็นแบบกลม ๆ ขอกลิ่นอาย Excel · ระวังอย่าแตะต้องฟอร์ม\"\n   .xl-doc ใส่ที่กล่องหลักของหน้าสร้าง/แก้ (wizard) และแถบเครื่องมือของหน้าดูใบ\n   ⚠ ทุกกฎยกเว้นแผ่นเอกสาร (QuotationPDF / InvoicePDF / TaxInvoicePDF: .break-after-page · .last-print-page · .print-area)\n     ฟอร์มเอกสารและการพิมพ์ต้องเหมือนเดิมทุกจุด */\n.xl-doc.bg-slate-50 { background-color: #f3f3f3 !important; }\n.xl-doc :is(.rounded, .rounded-md, .rounded-lg, .rounded-xl, .rounded-2xl, .rounded-3xl, [class*=\"rounded-[\"]):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px !important; }\n.xl-doc :is(button, a, label).rounded-full:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 4px !important; }\n.xl-doc :is(.shadow, .shadow-sm, .shadow-md, .shadow-lg, .shadow-xl, .shadow-2xl):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { box-shadow: 0 1px 2px rgba(0, 0, 0, .08) !important; }\n.xl-doc :is(input, select, textarea):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-radius: 3px !important; border-color: #b9c4bd; }\n.xl-doc :is(input, select, textarea):focus:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #217346 !important; box-shadow: 0 0 0 2px rgba(33, 115, 70, .2) !important; outline: none !important; }\n.xl-doc :is(.border-slate-100, .border-slate-200, .border-gray-100, .border-gray-200):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #c8d0ca !important; }\n/* สีหลัก (ดำ / น้ำเงิน / ม่วงคราม) → เขียว Excel */\n.xl-doc :is(.bg-slate-900, .bg-slate-800, .bg-black, .bg-blue-600, .bg-indigo-600):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #217346 !important; }\n.xl-doc :is(.hover\\:bg-slate-800, .hover\\:bg-slate-700, .hover\\:bg-blue-700, .hover\\:bg-indigo-700):hover:not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #185c37 !important; }\n.xl-doc :is(.text-blue-600, .text-indigo-600):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { color: #217346 !important; }\n.xl-doc :is(.bg-blue-50, .bg-indigo-50):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { background-color: #e3efe6 !important; }\n.xl-doc :is(.border-blue-500, .border-indigo-500, .border-slate-900):not(.print-area *):not(.break-after-page *):not(.last-print-page *):not(.break-after-page):not(.last-print-page) { border-color: #217346 !important; }\n\n/* แถบเครื่องมือหน้าดูใบ (ใบเสนอราคา / ใบแจ้งหนี้ / ใบกำกับ) บน iPad — เดิมบีบจนชื่อใบแตกคำละบรรทัด ปุ่มตัวหนังสือหัก\n   (20 ต.ค. 69) → ให้กลุ่มขึ้นบรรทัดใหม่แทน · ชื่อและปุ่มไม่ตัดคำ · ไม่แตะแผ่นเอกสาร */\n.xl-doc.no-print > div { flex-wrap: wrap; row-gap: .5rem; column-gap: .75rem; }\n.xl-doc.no-print > div > div { flex-wrap: wrap; row-gap: .5rem; }\n.xl-doc.no-print :is(button, a, h1, label) { white-space: nowrap; }\n.xl-doc.no-print > div > div:last-child { margin-left: auto; }\n.xl-doc.no-print .mr-2 { margin-right: 0 !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
